// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:39:22.194Z
// Property: 2050 Morningside (ID: 5656808622391296)
// Collections: 16 amenities, 13 floorplans (live), 26 photos, 82 POIs, 3 reviews, 4 virtual tours, 6 office hours, 1 special offers (live), 18 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5656808622391296",
  "property_external_id": "4981185",
  "property_zillow_url": "https://www.zillow.com/homedetails/2050-Cheshire-Bridge-Rd-NE-1026-Atlanta-GA-30324/2080483137_zpid/",
  "property_apartments_url": "https://www.apartments.com/2050-morningside-atlanta-ga/hmvb0y0",
  "property_google_business_url": "https://www.google.com/maps/place/2050+Morningside/@33.8118919,-84.3568671,15z/data=!4m2!3m1!1s0x0:0x866228ea995d0418?sa=X&ved=2ahUKEwjDguiX1P_2AhUtlGoFHYQwDRwQ_BJ6BAhgEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "2555093788",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "2050-morningside",
  "property_name": "2050 Morningside",
  "property_website_url": "https://www.2050morningside.com/",
  "property_domain": "https://www.2050morningside.com/",
  "property_address": "2050 Cheshire Bridge Rd NE",
  "property_full_address": "2050 Cheshire Bridge Rd NE, Atlanta, GA 30324",
  "property_address_1": "2050 Cheshire Bridge Rd NE",
  "property_address_2": null,
  "property_address_city": "Atlanta",
  "property_address_state": "GA",
  "property_address_zip_full": "30324-4346",
  "property_address_zip": "30324",
  "property_address_country": "US",
  "property_address_county": "Fulton County",
  "property_neighborhood_address": "Lindridge-Martin Manor",
  "property_address_latitude": "33.81219",
  "property_address_longitude": "-84.35634089999999",
  "property_email": "morningside@alapts.com",
  "property_phone": "(770) 299-2503",
  "property_call_tracking_phone": "470-339-1860",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Artful intown living between Midtown and Buckhead.</strong> Explore polished one- and two-bedroom apartments with quartz or marble countertops, wood-plank flooring, expansive windows, and everyday ease—then schedule a tour to see 2050 Morningside in person.</p>",
  "property_long_description": "<p><strong>Artful intown living between Midtown and Buckhead.</strong> At 2050 Morningside, you start with polished one- and two-bedroom apartments in Morningside & Lenox, then add the everyday perks that make the address feel effortless: full-size front-loading washers and dryers, Energy Star stainless steel appliances, quartz or marble countertops, wood-plank flooring, expansive windows, and bathrooms with garden tubs or walk-in showers.</p><p>Beyond your front door, <a href=\"/amenities\">community amenities</a> bring more places to reset or recharge, from the sun-splashed pool and courtyard lounge to the sky lounge, coffee bar, fitness center with Echelon Reflect Mirror, parcel lockers, bike storage and repair area, EV charging, and online resident services.</p><p>When you head out, <a href=\"/neighborhood\">Cheshire Bridge Road</a> puts dining, shops, and daily essentials close by, with easy access to I-85, I-75, GA-400, Lindbergh Center MARTA, Morningside Nature Preserve, Ansley Mall, Lenox Square, Phipps Plaza, Atlantic Station, Midtown, and Buckhead. Explore your next layout on the <a href=\"/floor-plans\">floor plans</a> page, then see the neighborhood come together in person.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019d02f0-49a4-753d-9b89-1eba80610943.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen island with marble countertop, bar stools, and pendant lighting.",
    "public_id": "019d02f0-49a4-753d-9b89-1eba80610943",
    "storage_key": "property/5656808622391296/019d02f0-49a4-753d-9b89-1eba80610943.webp",
    "width": 1240,
    "height": 680
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "198",
  "property_year_built": "2019",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.46464646464646",
  "property_admin_fee": "200",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Application Approval Fee: Starting at $250\nPet Fee: $350/pet Non-Refundable\nMonthly Pet Rent: $25/pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8879185.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://2050morningside.loftliving.com/login",
  "property_apply_now_url": "https://8879185.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019df5ba-f164-739e-904d-9ed3952880f0.webp",
  "property_primary_logo_media": {
    "alt_text": "2050 Morningside logo",
    "public_id": "019df5ba-f164-739e-904d-9ed3952880f0",
    "storage_key": "property/5656808622391296/019df5ba-f164-739e-904d-9ed3952880f0.webp",
    "width": 1166,
    "height": 506
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019d02f0-3ac9-7689-9e50-238992a5fd13.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f0-3ac9-7689-9e50-238992a5fd13",
    "storage_key": "property/5656808622391296/019d02f0-3ac9-7689-9e50-238992a5fd13.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019df5bb-2682-7278-991b-c0ee8ce80a61.webp",
  "property_icon_media": {
    "alt_text": "2050 MORNINGSIDE logo",
    "public_id": "019df5bb-2682-7278-991b-c0ee8ce80a61",
    "storage_key": "property/5656808622391296/019df5bb-2682-7278-991b-c0ee8ce80a61.webp",
    "width": 1544,
    "height": 1544
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019df5bb-2682-7278-991b-c0ee8ce80a61.webp",
  "property_fav_icon_media": {
    "alt_text": "2050 MORNINGSIDE logo",
    "public_id": "019df5bb-2682-7278-991b-c0ee8ce80a61",
    "storage_key": "property/5656808622391296/019df5bb-2682-7278-991b-c0ee8ce80a61.webp",
    "width": 1544,
    "height": 1544
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019df5bb-25d4-772c-9884-0e46d096d1d3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "2050 Morningside logo",
    "public_id": "019df5bb-25d4-772c-9884-0e46d096d1d3",
    "storage_key": "property/5656808622391296/019df5bb-25d4-772c-9884-0e46d096d1d3.webp",
    "width": 1166,
    "height": 506
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1943-450a-74b8-81f3-58befb66d239.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f1943-450a-74b8-81f3-58befb66d239",
    "storage_key": "property/5656808622391296/019f1943-450a-74b8-81f3-58befb66d239.webp",
    "width": 1166,
    "height": 506
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#091f40",
  "property_secondary_color": "#ef7338",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#575757",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "657 - 1151",
  "property_sqft_min": "657",
  "property_sqft_max": "1151",
  "property_price_range": "1548 - 2154",
  "property_price_min": "1548",
  "property_price_max": "2154",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/2050morningside",
  "property_instagram_url": "https://www.instagram.com/2050morningsideapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJFerFuy0F9YgRGARdmeooYoY",
  "property_youtube_url": "https://www.youtube.com/@2050MorningsideApartments",
  "property_yelp_url": "https://www.yelp.com/biz/2050-morningside-atlanta-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities that keep the day moving.</strong> Sip at the coffee bar, train with the Echelon Reflect Mirror, cool off at the courtyard pool, or take in skyline views from the sky lounge. At home, quartz or marble countertops, wood-plank flooring, stainless steel appliances, deep single-basin sinks, and full-size front-loading laundry add polish and ease. Parcel lockers, bike storage with repair, online services, and EV charging bring the practical perks.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts that work as beautifully as they look.</strong> Choose from one-bedroom apartments with smart, open flow or two-bedroom, two-bath plans with added room to spread out. At 2050 Morningside, each floor plan brings modern Atlanta style into focus with full-size front-loading laundry, Energy Star stainless steel appliances, quartz or marble countertops, wood-plank flooring, expansive windows, and sleek kitchens with deep single-basin sinks.</p>",
  "property_home_gallery_blurb": "<p><strong>See 2050 Morningside in focus.</strong> Browse bright interiors with broad kitchen islands, sleek counters, deep single-basin sinks, balcony-connected living rooms, and bedrooms filled with natural light. Then preview the polished spaces beyond your door, from window-side lounge seating and a focused fitness area to the sky lounge with fire pit, bar seating, and a pool courtyard made for an easy reset.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Cheshire Bridge buzz meets Morningside green.</strong> Grab tacos at Taqueria del Sol, plan dinner at Nakato, catch a film at Tara Theatre, or reset on the shaded trails of Morningside Nature Preserve. From 2050 Morningside, Lindbergh Center MARTA, I-85, Buckhead, Midtown, and everyday dining and shopping corridors stay close—making it easy to map your next stop.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents notice the details.</strong> Reviews for 2050 Morningside highlight responsive service, quick maintenance, beautiful apartments, and amenities that make daily life feel easy. Pet-friendly touches like the outdoor dog space, clean community areas, and resident events also stand out—along with praise for a team described as professional, kind, and timely. Read the reviews to see why “comfort, location, community, management” keeps coming up.</p>",
  "property_neighborhood_blurb": "<p><strong>Cheshire Bridge energy, Morningside calm.</strong> Step out for tacos at Taqueria del Sol, dinner at Nakato, or an indie film at the revived Tara Theatre, then trade the city buzz for shaded trails and creek views at Morningside Nature Preserve. From Lindridge-Martin Manor, you’re tucked into a leafy intown pocket with quick routes to Lindbergh Center MARTA, I-85, and the shopping and dining corridors that connect Morningside, Buckhead, and Midtown. Use the map below to trace your everyday circuit—from coffee and groceries to parks, transit, and night-out stops—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location feels in real time.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>More ways to reset, recharge, and simplify the day.</strong> At 2050 Morningside, amenities are designed to move with your routine: start at the coffee bar, train in the fitness center with Echelon Reflect Mirror, cool off by the courtyard pool, or unwind above it all in the sky lounge. Inside your apartment, polished finishes—quartz or marble countertops, wood-plank flooring, stainless steel appliances, deep single-basin sinks, and an included full-size front-loading washer and dryer—keep daily living streamlined.</p><p>Practical perks round out the experience, from parcel lockers and online resident services to bike storage with a repair area and EV charging. Browse the <a href=\"/gallery\">photo gallery</a> to see the spaces, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the details in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready for artful intown living?</strong><br>Start your online application for polished one- or two-bedroom apartments with full-size front-loading washers and dryers, Energy Star stainless steel appliances, quartz or marble countertops, wood-plank flooring, and expansive windows—all in a Cheshire Bridge Road setting between Midtown and Buckhead.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the leasing team at 2050 Morningside for details on polished one- and two-bedroom apartments, current availability, or directions to our intown Atlanta address between Midtown and Buckhead.</p>",
  "property_faqs_blurb": "<p><strong>Have questions about 2050 Morningside?</strong> Start here for quick answers on the community, leasing, amenities, and everyday living in our polished one- and two-bedroom apartments between Midtown and Buckhead. If you need anything more specific, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that feels right from the first look.</strong> Browse one-bedroom apartments with smart, easy-flowing living space or step into a two-bedroom, two-bath plan with extra room to spread out. Each option at 2050 Morningside pairs modern Atlanta apartment living with details that make the floor plan work harder: full-size front-loading washer and dryer, Energy Star stainless steel appliances, quartz or marble countertops, wood-plank flooring, expansive windows, and kitchens with deep single-basin sinks.</p><p>Use the cards below to compare available layouts, pricing, and move-in timing, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your next space comes together.</p>",
  "property_gallery_blurb": "<p><strong>Let the images fill in the details.</strong> In the 2050 Morningside photo gallery, you can move from bright apartment interiors to polished gathering spaces and outdoor retreats in just a few clicks. Picture a kitchen framed by a broad island, sleek counters, and a deep single-basin sink; a living room that opens toward a balcony; or a bedroom styled with bold color and expansive natural light.</p><p>Beyond the apartment door, the scenes keep unfolding: window-side seating in the resident lounge, a fitness space with room to focus, a sky lounge with a fire pit and bar seating, and a pool courtyard made for an easy reset. After you browse the photos, compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your next move.</strong> Explore available one- and two-bedroom apartments at 2050 Morningside, then zoom out to see how Cheshire Bridge Road connects you to dining, shops, daily essentials, major highways, MARTA, Midtown, Buckhead, and nearby green space.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with room to roam.</strong> Bring your cat, dog, or both to 2050 Morningside, where your daily routine can work around paws as easily as it works around you. With no weight limit in the policy, in-home hard-surface flooring, and a <a href=\"/amenities\">Posh Pet Spa</a> on site, quick cleanups and post-walk rinses feel simple.</p><p>Step out for fresh air in the courtyard, head to nearby wooded trails when your dog needs a bigger outing, or lean on Cheshire Bridge pet services for daycare, grooming, boarding, and vet visits close to home. Breed restrictions may apply, so check the details below or <a href=\"/contact-us\">ask the leasing team</a> about your pet before you choose your next apartment.</p>",
  "property_referafriend_blurb": "<p><strong>Share artful intown living.</strong> If you love the polished finishes, effortless amenities, and connected Cheshire Bridge Road location at 2050 Morningside, invite a friend to see it for themselves. Send a referral and help them find their next one- or two-bedroom apartment here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made effortless.</strong> Use the online resident services at 2050 Morningside to pay rent, submit maintenance requests, and manage account details—so everyday tasks stay as polished and convenient as life at this artful intown address.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying.</strong> Reviews for 2050 Morningside point to the details that make everyday living feel well supported: responsive office staff, quick maintenance, beautiful apartments, and amenities residents enjoy using. One resident summed it up simply: “comfort, location, community, management, it's a great place to live.”</p><p>You’ll also see appreciation for the property’s pet-friendly atmosphere, dedicated outdoor dog space, clean surroundings, and community events that add another layer to the experience. As you read through the ratings, look for the recurring praise around professional, kind service and timely support—details that help turn a good apartment into a place you can feel confident calling home.</p>",
  "property_created_at": "1752256417034",
  "property_scheduletour_blurb": "<p><strong>See 2050 Morningside in person.</strong> Tour polished one- and two-bedroom apartments with expansive windows, wood-plank flooring, quartz or marble countertops, and full-size front-loading laundry—then get a feel for the pool, sky lounge, coffee bar, and intown setting between Midtown and Buckhead.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out.</strong><br>Your submission has been received, and the leasing team will follow up soon. In the meantime, picture artful intown living at 2050 Morningside, with polished one- and two-bedroom apartments, elevated finishes, and inviting spaces to reset, recharge, and feel at home.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you arrive.</strong> Explore 2050 Morningside through immersive virtual tours that let you move at your own pace—from the two-bedroom, two-bath B1 apartment to the fitness center, pool, and sky lounge. Start in the apartment walkthrough to get a clearer feel for the open living area, modern kitchen finishes, in-home laundry, and the way each room connects.</p><p>Then shift into the community spaces: check out the equipment layout in the fitness center, picture the pool courtyard from more than one angle, and take in the sky lounge’s elevated setting, seating, and fire-pit atmosphere. When you’re ready to compare layouts or see it in person, browse <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_copyright": "2025 All Rights Reserved. 2050 Morningside",
  "property_seo_title_home": "2050 Morningside | Apartments in Atlanta, GA",
  "property_seo_description_home": "\"Elevate your lifestyle at 2050 Morningside, Atlanta's premier apartment community. Choose from spacious one and two-bedroom floor plans, all featuring luxurious amenities like a stunning rooftop sky lounge, serene courtyard, and a state-of-the-art fitness center. Engage with your neighbors at our vibrant coffee bar, unwind in the expansive pool, or enjoy the gorgeous wooded views from your private balcony. Experience convenience with online resident services and package delivery systems. Your new home awaits—embrace exceptional living at 2050 Morningside today!\"",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Atlanta, GA",
  "property_seo_description_floorplans": "Unveil the perfect blend of comfort and style at 2050 Morningside in Atlanta, GA. Our thoughtfully designed one and two-bedroom floor plans cater to every lifestyle, inviting you to envision your dream home. Ready to indulge in spacious living? Browse our available apartment homes and choose the ideal layout that reflects your unique vision!",
  "property_seo_title_amenities": "Amenities | Atlanta, GA Apartments for Rent",
  "property_seo_description_amenities": "Elevate your living experience at 2050 Morningside in Atlanta, GA. Indulge in luxurious one and two-bedroom apartments featuring stunning views, modern finishes, and exclusive amenities like a rooftop sky lounge, inviting courtyard, and state-of-the-art fitness center. Unwind by the pool or savor your morning brew at our cozy coffee bar. With convenient online resident services and a bike repair area, your lifestyle is simplified. Embrace comfort and community - your perfect apartment awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Atlanta, GA",
  "property_seo_description_gallery": "\"Step into the vibrant lifestyle at 2050 Morningside in Atlanta, GA, where stunning one and two-bedroom floor plans meet upscale amenities, like a rooftop sky lounge, relaxing courtyard, and a fully-equipped fitness center. Imagine unwinding by the pool, sipping coffee at our inviting café, or hosting friends on your private balcony with beautiful wooded views. Browse our photo gallery to see the exceptional living experience waiting for you—your dream home starts here!\"",
  "property_seo_title_virtualtours": "Virtual Tours | 2050 Morningside Apartments",
  "property_seo_description_virtualtours": "Step inside 2050 Morningside, where Atlanta's charm meets stylish living! Browse through our spacious one and two-bedroom floor plans, designed to elevate your lifestyle. Ready for a sneak peek? Take a virtual tour of our vibrant community and find your perfect apartment today!",
  "property_seo_title_interactivemap": "Interactive Map | 2050 Morningside Apartments",
  "property_seo_description_interactivemap": "\"Elevate your lifestyle at 2050 Morningside in Atlanta, GA – where modern design meets comfort. Our diverse floor plans, from chic one-bedroom to spacious two-bedroom layouts, cater to all your needs. Enjoy resort-style amenities like a rooftop sky lounge with stunning views, a refreshing pool, and a well-equipped fitness center. Relish in the comforts of hard floors, garden tubs, and private patios. With our interactive community map, your dream apartment is just a click away. Start your new journey today!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Atlanta, GA",
  "property_seo_description_neighborhood": "Experience the vibrant lifestyle of Atlanta at 2050 Morningside, where our one and two-bedroom apartments are perfectly situated near the city's best attractions. Dive into the neighborhood's rich selection of local favorites and exciting hotspots. Ready to find your new home and enjoy everything our community has to offer? Check out the area today!",
  "property_seo_title_contact": "Contact Us | 2050 Morningside",
  "property_seo_description_contact": "Experience modern living at 2050 Morningside in Atlanta, GA! Our thoughtfully designed one and two-bedroom apartment floor plans cater to your lifestyle needs. Whether you’re seeking cozy comfort or spacious layouts, we’ve got you covered. Have questions? Connect with our friendly leasing team today for personalized assistance!",
  "property_seo_title_faqs": "FAQs | Apartments in Atlanta, GA",
  "property_seo_description_faqs": "Unravel the charm of 2050 Morningside in Atlanta, GA, where modern living meets thoughtful design. From our well-appointed one and two-bedroom apartments to luxurious amenities like a rooftop sky lounge, refreshing pool, and a cozy coffee bar, every detail is crafted for your lifestyle. Curious about our community? Dive into our FAQs page for insightful answers about living at 2050 Morningside and make your next move a breeze!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Atlanta, GA",
  "property_seo_description_reviews": "\"Experience the vibrant lifestyle at 2050 Morningside in Atlanta, GA, where our stunning one and two-bedroom floor plans meet luxurious amenities, from a rooftop sky lounge to a refreshing pool. Hear firsthand from our residents about how our coffee bar, fitness center, and online services enhance their daily lives. Dive into the community spirit and see why 2050 Morningside feels like home.\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Atlanta, GA",
  "property_seo_description_applynow": "\"Step into modern living at 2050 Morningside in vibrant Atlanta, GA! Choose from stylish one and two-bedroom floor plans, designed for comfort and convenience. Enjoy exclusive amenities like a rooftop sky lounge, refreshing pool, and a chic coffee bar. With online resident services, bike storage, and tranquil wooded views, your ideal lifestyle awaits. Don't wait—secure your perfect apartment today and elevate your everyday living!\"",
  "property_seo_title_residentaccess": "Resident Access | 2050 Morningside",
  "property_seo_description_residentaccess": "\"Welcome to the 2050 Morningside resident portal—your key to hassle-free living in Atlanta! Effortlessly pay rent, schedule maintenance, and access exclusive community updates all in one place. Log in today and enjoy the convenience at your fingertips!\"",
  "property_seo_title_referafriend": "Refer A Friend | 2050 Morningside",
  "property_seo_description_referafriend": "\"Bring your friends along to 2050 Morningside in Atlanta, GA! Great friends make for great neighbors—share the joy of vibrant living with your loved ones. Refer a friend today and enjoy exclusive rewards!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | 2050 Morningside",
  "property_seo_description_scheduletour": "\"Step into vibrant living at 2050 Morningside in Atlanta, GA. Experience the heart of our community with modern amenities, lush surroundings, and friendly faces. Ready to make it home? Schedule a tour today and envision your new lifestyle!\"",
  "property_seo_title_privacy": "Privacy Policy | 2050 Morningside",
  "property_seo_description_privacy": "Your privacy matters at 2050 Morningside in vibrant Atlanta. Our privacy policy outlines how we protect your information while you enjoy a seamless living experience. Transparency is our promise—view our policy to learn more!",
  "property_seo_title_accessibility": "Website Accessibility | 2050 Morningside",
  "property_seo_description_accessibility": "\"At 2050 Morningside in Atlanta, GA, we prioritize accessibility for all. Our commitment to digital inclusion ensures everyone can experience the vibrant community we offer. Join us in embracing a space where comfort meets convenience, and inclusivity is at the heart of everything we do.\"",
  "property_seo_title_sitemap": "Sitemap | 2050 Morningside",
  "property_seo_description_sitemap": "Navigate your way to your dream home at 2050 Morningside in vibrant Atlanta, GA. Our sitemap offers a clear path to explore available floor plans, amenities, and community highlights. Start your journey to a new lifestyle today!",
  "property_seo_title_thankyou": "Thank You | 2050 Morningside",
  "property_seo_description_thankyou": "\"Thank you for reaching out to 2050 Morningside in vibrant Atlanta, GA! Your journey to exceptional living starts here. Stay tuned as our team prepares to connect with you and unveil the unique lifestyle waiting just outside your door.\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319339",
  "amenities": [
    {
      "id": "custom_05653097-4830-4925-90d0-1c38774c86ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_030a8d62-461b-4bd5-93e2-fd60e7212e12",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Gourmet Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_53c30ae8-f456-48b2-8ae5-65027ac59255",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Quartz or Marble Countertops",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba04d67d-2b02-410c-9e0d-8d96fd65e0a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000622",
      "title": "Courtyard",
      "amount": "0.0000",
      "description": "Resident Courtyard",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_29962675-6fa6-4d76-b805-902ef091f8e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c6630462-2ec8-43b7-8928-1de9a48bb78a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Garden Tubs & Walk-In Showers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ba38456-615c-4b51-8794-17dd004a9d1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_57dd4e88-9ea6-4b31-9cd7-93b74b486014",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9230030-b3b5-4208-8937-8ce8b70cdf92",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38787cc0-5a2f-4b4d-b13a-90f77ab8100b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "24-Hour Resident Package System",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d90ff551-edef-40f9-8389-d3831657e106",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c8aa112-83b1-49a4-aa4a-49296718b08d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Deep, Single-Basin Sinks",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7db09dd9-36ba-49b1-9821-e4376ae8272e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c368145e-d49e-47bd-9fd4-30a7b094a527",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Sky Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b563cc2-4bc4-42ff-9d6c-4e7d5aba88cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000002333",
      "title": "Wine Rack",
      "amount": "0.0000",
      "description": "Complimentary Wine Tap",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a0223eb2-dd27-42fa-ae61-de46d90afc6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "external_id": "P000002447",
      "title": "Bike Storage and Repair Area",
      "amount": "0.0000",
      "description": "Bike Storage and Repair Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_c1c6fcb3-e3f4-4461-8110-bde7fee4f422",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-e5de-76df-ac42-26cb8c0fd9b1.webp",
      "image_media": {
        "alt_text": "Apartment building courtyard with a swimming pool and lounge chairs.",
        "public_id": "019e8974-e5de-76df-ac42-26cb8c0fd9b1",
        "storage_key": "property/5656808622391296/019e8974-e5de-76df-ac42-26cb8c0fd9b1.webp",
        "width": 1434,
        "height": 956
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool or lounge in one of our comfortable chairs. This vibrant courtyard is perfect for unwinding.",
      "link": "",
      "alt_text": "Apartment building courtyard with a swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b122fc2-778f-4187-bf12-c4eedd000ed9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-e71a-730a-b3b5-97d49fbc4ba8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island with bar stools.",
        "public_id": "019e8974-e71a-730a-b3b5-97d49fbc4ba8",
        "storage_key": "property/5656808622391296/019e8974-e71a-730a-b3b5-97d49fbc4ba8.webp",
        "width": 1434,
        "height": 956
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring sleek gray cabinetry, a breakfast bar with seating, and an open layout flowing into the living area.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4483ba07-edb5-456b-9a17-59312007f874",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-e5d1-759d-b97d-2d8f0247a7f1.webp",
      "image_media": {
        "alt_text": "Modern lounge area with yellow accent chairs and large windows.",
        "public_id": "019e8974-e5d1-759d-b97d-2d8f0247a7f1",
        "storage_key": "property/5656808622391296/019e8974-e5d1-759d-b97d-2d8f0247a7f1.webp",
        "width": 640,
        "height": 481
      },
      "title": "Community",
      "description": "Relax in style in our beautifully designed lounge, featuring comfortable seating and abundant natural light. A perfect space to unwind or socialize.",
      "link": "",
      "alt_text": "Modern lounge area with yellow accent chairs and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_01beef6d-8c1e-4330-a4f5-5345df75e751",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-e445-75ec-b462-5bce8b0c9063.webp",
      "image_media": {
        "alt_text": "Living room with a blue accent wall, gray sofa, white shag rug, and patterned curtains.",
        "public_id": "019e8974-e445-75ec-b462-5bce8b0c9063",
        "storage_key": "property/5656808622391296/019e8974-e445-75ec-b462-5bce8b0c9063.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Discover the stylish living room of our apartments, featuring a blue accent wall, comfortable seating, and chic decor. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a blue accent wall, gray sofa, white shag rug, and patterned curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24e6fbd4-68c1-46fe-a67f-742e353c9473",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-e313-7010-9343-c538100d946e.webp",
      "image_media": {
        "alt_text": "A bedroom with a large bed, blue curtains, and a wall decorated with empty picture frames.",
        "public_id": "019e8974-e313-7010-9343-c538100d946e",
        "storage_key": "property/5656808622391296/019e8974-e313-7010-9343-c538100d946e.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Relax in this stylish bedroom featuring a comfortable bed, elegant curtains, and a unique decorative wall. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "A bedroom with a large bed, blue curtains, and a wall decorated with empty picture frames.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b8bdbc94-228d-4a4b-81c4-79626749398e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-e03b-7549-a063-9f3172f90b8b.webp",
      "image_media": {
        "alt_text": "Modern lounge area with teal sectional sofas, coffee table, and accent wall.",
        "public_id": "019e8974-e03b-7549-a063-9f3172f90b8b",
        "storage_key": "property/5656808622391296/019e8974-e03b-7549-a063-9f3172f90b8b.webp",
        "width": 640,
        "height": 481
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish lounge, featuring comfortable seating, a modern coffee table, and a decorative accent wall.",
      "link": "",
      "alt_text": "Modern lounge area with teal sectional sofas, coffee table, and accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21a39c0a-ac72-4dbd-86a7-3789b629b551",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-dc54-7772-9db5-e1895346bcc2.webp",
      "image_media": {
        "alt_text": "Modern gray kitchen with stainless steel appliances and marble countertops.",
        "public_id": "019e8974-dc54-7772-9db5-e1895346bcc2",
        "storage_key": "property/5656808622391296/019e8974-dc54-7772-9db5-e1895346bcc2.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring gray cabinetry, stainless steel appliances, subway tile backsplash, and gleaming marble countertops.",
      "link": "",
      "alt_text": "Modern gray kitchen with stainless steel appliances and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_53c037c7-670c-4e0b-bc39-1d9b91d44f80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d928-75d9-9956-ee444f1e8e46.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity, large mirror, toilet, and walk-in closet.",
        "public_id": "019e8974-d928-75d9-9956-ee444f1e8e46",
        "storage_key": "property/5656808622391296/019e8974-d928-75d9-9956-ee444f1e8e46.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity with marble countertops, a large mirror, a convenient walk-in closet, and a toilet.",
      "link": "",
      "alt_text": "Modern bathroom with a double vanity, large mirror, toilet, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ab195a05-56c1-4a46-a6c7-16e25b46b945",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d5dc-7568-a0dc-6ee5001dfc2e.webp",
      "image_media": {
        "alt_text": "Modern living room with blue sofa, marble coffee table, and open-plan kitchen.",
        "public_id": "019e8974-d5dc-7568-a0dc-6ee5001dfc2e",
        "storage_key": "property/5656808622391296/019e8974-d5dc-7568-a0dc-6ee5001dfc2e.webp",
        "width": 1434,
        "height": 956
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring a comfortable blue sofa, chic coffee table, and a sleek, modern kitchen perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with blue sofa, marble coffee table, and open-plan kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9fa2a956-900f-459a-b65d-c2f97be01e50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d96f-746f-ad74-f83ae17de435.webp",
      "image_media": {
        "alt_text": "Rooftop patio area with fire pit, grills, and seating.",
        "public_id": "019e8974-d96f-746f-ad74-f83ae17de435",
        "storage_key": "property/5656808622391296/019e8974-d96f-746f-ad74-f83ae17de435.webp",
        "width": 640,
        "height": 481
      },
      "title": "Community",
      "description": "Enjoy the outdoors on our rooftop patio, complete with a cozy fire pit, multiple grills for entertaining, and comfortable seating areas.",
      "link": "",
      "alt_text": "Rooftop patio area with fire pit, grills, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e749a93b-8048-4a06-a1dc-f29b3e81e6a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d889-759c-ab2d-7ca129ee6c83.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with weights, punching bag, and cardio machines.",
        "public_id": "019e8974-d889-759c-ab2d-7ca129ee6c83",
        "storage_key": "property/5656808622391296/019e8974-d889-759c-ab2d-7ca129ee6c83.webp",
        "width": 640,
        "height": 481
      },
      "title": "Community",
      "description": "Enjoy our state-of-the-art fitness center, fully equipped with everything you need for a great workout. Includes cardio machines, free weights, and a boxing area.",
      "link": "",
      "alt_text": "Modern apartment gym with weights, punching bag, and cardio machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9075be2f-2976-43db-b86f-15eeb4a8a788",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d324-709a-bfec-49efbf45920a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island with seating.",
        "public_id": "019e8974-d324-709a-bfec-49efbf45920a",
        "storage_key": "property/5656808622391296/019e8974-d324-709a-bfec-49efbf45920a.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Sleek and modern kitchen featuring ample counter space, stainless steel appliances, and a breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2df87c04-3370-4bf1-9ea1-fb88bfc9c48a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d134-75e4-9c86-7b0dfb7bd39c.webp",
      "image_media": {
        "alt_text": "A modern living room with a blue accent wall and large windows.",
        "public_id": "019e8974-d134-75e4-9c86-7b0dfb7bd39c",
        "storage_key": "property/5656808622391296/019e8974-d134-75e4-9c86-7b0dfb7bd39c.webp",
        "width": 1639,
        "height": 1092
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, decorative wall art, and a large rug, perfect for relaxing.",
      "link": "",
      "alt_text": "A modern living room with a blue accent wall and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8282ccd0-402b-416c-a0bf-086f3959c349",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d1ca-72f3-8863-51d6e51ad3bf.webp",
      "image_media": {
        "alt_text": "Rooftop outdoor lounge area with fire pit, seating, bar seating, and string lights.",
        "public_id": "019e8974-d1ca-72f3-8863-51d6e51ad3bf",
        "storage_key": "property/5656808622391296/019e8974-d1ca-72f3-8863-51d6e51ad3bf.webp",
        "width": 1434,
        "height": 955
      },
      "title": "Community",
      "description": "Enjoy the fresh air and stunning views from our rooftop lounge, featuring a cozy fire pit, comfortable seating, and a bar area perfect for socializing.",
      "link": "",
      "alt_text": "Rooftop outdoor lounge area with fire pit, seating, bar seating, and string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_597ff9e2-1066-435c-8caa-23fb2fb3c393",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d39f-7574-b120-babe630ea28d.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two stainless steel grills on a rooftop patio with seating and a pergola.",
        "public_id": "019e8974-d39f-7574-b120-babe630ea28d",
        "storage_key": "property/5656808622391296/019e8974-d39f-7574-b120-babe630ea28d.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our rooftop grilling station, complete with two professional-grade grills and comfortable lounge seating, perfect for entertaining.",
      "link": "",
      "alt_text": "Outdoor grilling station with two stainless steel grills on a rooftop patio with seating and a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f8d8b03a-4e03-4da8-909c-c900a1204786",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-d26d-71d9-ac71-0b3d256f65b6.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with teal sofas, modern coffee table, and large windows overlooking an outdoor area.",
        "public_id": "019e8974-d26d-71d9-ac71-0b3d256f65b6",
        "storage_key": "property/5656808622391296/019e8974-d26d-71d9-ac71-0b3d256f65b6.webp",
        "width": 640,
        "height": 481
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a contemporary design, and ample natural light. Perfect for socializing or quiet enjoyment.",
      "link": "",
      "alt_text": "Spacious community lounge with teal sofas, modern coffee table, and large windows overlooking an outdoor area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_26c4ec2e-6107-4d53-a4a3-ba2522613d11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-c966-76ce-b095-ecd17184c2ff.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, green accent wall, and modern decor.",
        "public_id": "019e8974-c966-76ce-b095-ecd17184c2ff",
        "storage_key": "property/5656808622391296/019e8974-c966-76ce-b095-ecd17184c2ff.webp",
        "width": 1639,
        "height": 1092
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully appointed bedrooms, featuring a queen-size bed, chic accent wall, and contemporary furnishings for a truly relaxing retreat.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed, green accent wall, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_95bb60c9-07ad-4b10-baeb-54d5cadb5de3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-c687-757b-8c7c-207e4bac0387.webp",
      "image_media": {
        "alt_text": "Fitness center with spin bikes, rowing machines, and free weights.",
        "public_id": "019e8974-c687-757b-8c7c-207e4bac0387",
        "storage_key": "property/5656808622391296/019e8974-c687-757b-8c7c-207e4bac0387.webp",
        "width": 1639,
        "height": 1092
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with cardio machines and weights for your workout needs.",
      "link": "",
      "alt_text": "Fitness center with spin bikes, rowing machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0f6578bd-b758-4116-9c5c-a6922705a1a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-bf87-71ee-92a2-88471c1e5fba.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with a fire pit, seating, and tables under a pergola.",
        "public_id": "019e8974-bf87-71ee-92a2-88471c1e5fba",
        "storage_key": "property/5656808622391296/019e8974-bf87-71ee-92a2-88471c1e5fba.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our community lounge area, featuring a fire pit, comfortable seating, and shaded pergolas for relaxation and socializing.",
      "link": "",
      "alt_text": "Outdoor lounge area with a fire pit, seating, and tables under a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67ea21df-2a20-4fef-884e-b95e9db77b28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-c1f6-7628-8580-80a6cb4a2999.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and walk-in closet. Features include a marble countertop, subway tile shower, and blue patterned shower curtain.",
        "public_id": "019e8974-c1f6-7628-8580-80a6cb4a2999",
        "storage_key": "property/5656808622391296/019e8974-c1f6-7628-8580-80a6cb4a2999.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom featuring a sleek vanity with a marble countertop, a convenient walk-in closet, and a bathtub with a decorative shower curtain. The perfect blend of form and function.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and walk-in closet. Features include a marble countertop, subway tile shower, and blue patterned shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16e49167-bfa9-4ac4-a80f-c9048b2f5d1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-bfad-718e-842a-30a6a356427f.webp",
      "image_media": {
        "alt_text": "Fitness center with spin bikes and treadmills",
        "public_id": "019e8974-bfad-718e-842a-30a6a356427f",
        "storage_key": "property/5656808622391296/019e8974-bfad-718e-842a-30a6a356427f.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring spin bikes, treadmills, and elliptical machines for a complete workout experience.",
      "link": "",
      "alt_text": "Fitness center with spin bikes and treadmills",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c73ad11-7324-41a0-a2c0-404687f05611",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-c13a-7039-9bc9-946de136470e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with grey cabinets, marble countertops, and stainless steel appliances.",
        "public_id": "019e8974-c13a-7039-9bc9-946de136470e",
        "storage_key": "property/5656808622391296/019e8974-c13a-7039-9bc9-946de136470e.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Stylish apartment kitchen featuring sleek grey cabinetry, a spacious marble island with seating, and an open layout connecting to the living area.",
      "link": "",
      "alt_text": "Modern kitchen with grey cabinets, marble countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_46cfafd8-f0fa-4a17-828f-51c018e6d552",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-bedd-748a-895f-01ccdd143c65.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, green accent wall, and modern decor.",
        "public_id": "019e8974-bedd-748a-895f-01ccdd143c65",
        "storage_key": "property/5656808622391296/019e8974-bedd-748a-895f-01ccdd143c65.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this beautifully appointed bedroom, featuring a queen-size bed, chic bedding, and a vibrant green accent wall. Perfect for relaxation.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed, green accent wall, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0fca07d7-fd0c-465d-af01-05439cc66399",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-c2b5-74ea-8390-adcad9797ef3.webp",
      "image_media": {
        "alt_text": "Modern apartment complex courtyard with a swimming pool and lounge chairs.",
        "public_id": "019e8974-c2b5-74ea-8390-adcad9797ef3",
        "storage_key": "property/5656808622391296/019e8974-c2b5-74ea-8390-adcad9797ef3.webp",
        "width": 640,
        "height": 481
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, surrounded by comfortable lounge seating and lush landscaping. Enjoy the resort-style amenities at our apartment community.",
      "link": "",
      "alt_text": "Modern apartment complex courtyard with a swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e21e2f7-5e7e-4b32-a2e9-411034a090d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-bea5-7328-b2e1-904505397f80.webp",
      "image_media": {
        "alt_text": "Modern living room with teal couches and a decorative ceiling.",
        "public_id": "019e8974-bea5-7328-b2e1-904505397f80",
        "storage_key": "property/5656808622391296/019e8974-bea5-7328-b2e1-904505397f80.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Relax in style in our beautifully designed community living room, featuring plush seating and elegant decor.",
      "link": "",
      "alt_text": "Modern living room with teal couches and a decorative ceiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d38f562d-3d58-4dcd-80a7-c4029ccabf7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019e8974-bfde-73d3-8b0f-5a156386dd0c.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings surrounding a courtyard swimming pool with lounge chairs.",
        "public_id": "019e8974-bfde-73d3-8b0f-5a156386dd0c",
        "storage_key": "property/5656808622391296/019e8974-bfde-73d3-8b0f-5a156386dd0c.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy the resort-style living at our community, featuring a sparkling swimming pool perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Modern apartment buildings surrounding a courtyard swimming pool with lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_b564b262220a293df2261a06",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "The Colonnade",
      "poi_type": "Restaurants",
      "poi_address": "1879 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Local institution serving fare like fried chicken & coleslaw in an unpretentious space.",
      "poi_long_description": "Local institution serving fare like fried chicken & coleslaw in an unpretentious space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-e5cb-767e-a803-73d97931e033.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-e5cb-767e-a803-73d97931e033",
        "storage_key": "property/5656808622391296/019f1516-e5cb-767e-a803-73d97931e033.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.thecolonnadeatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12362991284510993738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-colonnade",
      "poi_latitude": "33.809249",
      "poi_longitude": "-84.36101959999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-874-5642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuZoiGdEF9YgRSi2HQhIrkqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_e1c05073f9d5c41d743d820c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Gino's NY Pizza Bar",
      "poi_type": "Restaurants",
      "poi_address": "1740 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "A casual pizza place also serving pasta & desserts like cannoli, with a full bar & ample seating.",
      "poi_long_description": "A casual pizza place also serving pasta & desserts like cannoli, with a full bar & ample seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-e6fb-74eb-91ff-38c9c14fcf32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-e6fb-74eb-91ff-38c9c14fcf32",
        "storage_key": "property/5656808622391296/019f1516-e6fb-74eb-91ff-38c9c14fcf32.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ginosnypizzabaratl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11698042591242034414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ginos-ny-pizza-bar",
      "poi_latitude": "33.80828",
      "poi_longitude": "-84.365523",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-874-4466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTS_MEc4F9YgR7hxfAsLLV6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_881dd65f9c91203fa6d6b712",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Six Feet Under Pub & Fish House - Cheshire Bridge",
      "poi_type": "Restaurants",
      "poi_address": "1824 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Fish, seafood and southern-style dishes are served alongside cocktails and beer at this patio-equipped pub.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-e015-765a-ac6f-c5ea1a44414e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-e015-765a-ac6f-c5ea1a44414e",
        "storage_key": "property/5656808622391296/019f1516-e015-765a-ac6f-c5ea1a44414e.webp",
        "width": 1200,
        "height": 1276
      },
      "poi_business_url": "https://www.sixfeetunder.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14468782873307729800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-feet-under-pub--fish-house---cheshire-bridge",
      "poi_latitude": "33.8093214",
      "poi_longitude": "-84.36303600000001",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 470-762-0733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFxBcqyEF9YgRiE_DR11xy8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_55bac64df37425cf7937351c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Tribeca Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1782 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-e018-77b3-9433-aa66a5eeeae7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-e018-77b3-9433-aa66a5eeeae7",
        "storage_key": "property/5656808622391296/019f1516-e018-77b3-9433-aa66a5eeeae7.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13707781596761782167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tribeca-restaurant",
      "poi_latitude": "33.808754",
      "poi_longitude": "-84.3642333",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-343-1708",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6by4MwsF9YgRl3efPbzSO74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_313e16838d404029064d80c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Nino's Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1931 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Cozy local spot for Italian cuisine has a throwback vibe & menu featuring red-sauce classics.",
      "poi_long_description": "Cozy local spot for Italian cuisine has a throwback vibe & menu featuring red-sauce classics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-e0ab-75a4-800d-898abf11feb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-e0ab-75a4-800d-898abf11feb2",
        "storage_key": "property/5656808622391296/019f1516-e0ab-75a4-800d-898abf11feb2.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://ninosatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3806727883065905047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ninos-italian-restaurant",
      "poi_latitude": "33.810037",
      "poi_longitude": "-84.3596123",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-874-6505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNRziKtEF9YgRl8-3Otc21DQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_04c4d9b810a45f9eb8d75f9a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Little Bangkok",
      "poi_type": "Restaurants",
      "poi_address": "2225 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Basic Thai spot also offering generous portions of Chinese dishes in a no-frills setting.",
      "poi_long_description": "Basic Thai spot also offering generous portions of Chinese dishes in a no-frills setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-e0c1-7672-b830-fd06aa9e5cab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-e0c1-7672-b830-fd06aa9e5cab",
        "storage_key": "property/5656808622391296/019f1516-e0c1-7672-b830-fd06aa9e5cab.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "http://www.littlebangkokatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5624288829817973484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-bangkok",
      "poi_latitude": "33.8158679",
      "poi_longitude": "-84.3523008",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-315-1530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2EXUHYG9YgR7Gp_V-R8DU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_fc7ca00117ac3c6e77304cf7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Daily Chew",
      "poi_type": "Restaurants",
      "poi_address": "2127 Liddell Dr NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Cafe serving coffee, breakfast bites like avocado toast and a gluten-free menu.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-e619-70ba-8229-647feb2a464a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-e619-70ba-8229-647feb2a464a",
        "storage_key": "property/5656808622391296/019f1516-e619-70ba-8229-647feb2a464a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://dailychewatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8454019116520155297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daily-chew",
      "poi_latitude": "33.8118946",
      "poi_longitude": "-84.3627279",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-600-4155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTQsuHmQD9YgRoaiLXJi1UnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_a209c8d75edb13da303531b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "STREET BISTRO",
      "poi_type": "Restaurants",
      "poi_address": "2184 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-e639-77bd-92d5-19c72b1157f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-e639-77bd-92d5-19c72b1157f3",
        "storage_key": "property/5656808622391296/019f1516-e639-77bd-92d5-19c72b1157f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://atlstreetbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17005873261672387917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "street-bistro",
      "poi_latitude": "33.8144699",
      "poi_longitude": "-84.3536611",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-325-7630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUZyVWV4H9YgRTdVLaaH_AOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_d60286f731fdd676854fc302",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Alon's Bakery & Market",
      "poi_type": "Restaurants",
      "poi_address": "1394 N Highland Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Relaxed bakery & sandwich shop featuring prepared foods & sweets in snug, old-school digs.",
      "poi_long_description": "Relaxed bakery & sandwich shop featuring prepared foods & sweets in snug, old-school digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-ecc0-74ed-82f5-1632a313519a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-ecc0-74ed-82f5-1632a313519a",
        "storage_key": "property/5656808622391296/019f1516-ecc0-74ed-82f5-1632a313519a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://alons.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7036550034639334907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alons-bakery--market",
      "poi_latitude": "33.7926156",
      "poi_longitude": "-84.35283059999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-872-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2Bj84IG9YgR-63wqvnYpmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_ed244a3ce9525537627f45b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "The Family Dog",
      "poi_type": "Restaurants",
      "poi_address": "1402 N Highland Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Casual outpost offers Southern twists on bar foods, plus a vast beer list & specialty cocktails.",
      "poi_long_description": "Casual outpost offers Southern twists on bar foods, plus a vast beer list & specialty cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-e053-757e-a2f8-e1de6dec5d42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-e053-757e-a2f8-e1de6dec5d42",
        "storage_key": "property/5656808622391296/019f1516-e053-757e-a2f8-e1de6dec5d42.webp",
        "width": 901,
        "height": 600
      },
      "poi_business_url": "http://thefamilydogatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9392866273467509971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-family-dog",
      "poi_latitude": "33.7925986",
      "poi_longitude": "-84.3524467",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-705-5324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLR8l8YIG9YgR0yzHNBwqWoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_27d2b14a57590548cea65716",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Doc Chey's Noodle House",
      "poi_type": "Restaurants",
      "poi_address": "1424 N Highland Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Branch of a casual chain eatery dishing noodles & stir-fries over rice & other classic Asian fare.",
      "poi_long_description": "Branch of a casual chain eatery dishing noodles & stir-fries over rice & other classic Asian fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-ebaf-7414-9d57-e6ae0e67b982.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-ebaf-7414-9d57-e6ae0e67b982",
        "storage_key": "property/5656808622391296/019f1516-ebaf-7414-9d57-e6ae0e67b982.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.doccheys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4777740415572427590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doc-cheys-noodle-house",
      "poi_latitude": "33.7932328",
      "poi_longitude": "-84.3518218",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-888-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY4HjV4IG9YgRRsM4K5jxTUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_fusion_restaurant"
    },
    {
      "id": "ec_d519c5019fd69080f44c68ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Whiskey Bird",
      "poi_type": "Restaurants",
      "poi_address": "1409 N Highland Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Grilled yakitori skewers & cross-cultural fusion plates (tacos, burgers) in an easygoing space.",
      "poi_long_description": "Grilled yakitori skewers & cross-cultural fusion plates (tacos, burgers) in an easygoing space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-eb39-704f-b488-6c42e0b04245.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-eb39-704f-b488-6c42e0b04245",
        "storage_key": "property/5656808622391296/019f1516-eb39-704f-b488-6c42e0b04245.webp",
        "width": 1210,
        "height": 864
      },
      "poi_business_url": "https://www.eatwhiskeybird.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9076985916829850387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whiskey-bird",
      "poi_latitude": "33.792656",
      "poi_longitude": "-84.351852",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-500-0575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2W3_oIG9YgRE9vdc5nu930",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_7b4a6c3456501d46b7f00078",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Manuel's Tavern",
      "poi_type": "Restaurants",
      "poi_address": "602 N Highland Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Longtime neighborhood bar with homestyle pub grub, dozens of beers on tap & a lively scene.",
      "poi_long_description": "Longtime neighborhood bar with homestyle pub grub, dozens of beers on tap & a lively scene.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-eebf-74b8-bc5a-749729112add.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-eebf-74b8-bc5a-749729112add",
        "storage_key": "property/5656808622391296/019f1516-eebf-74b8-bc5a-749729112add.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://manuelstavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17206317761868439050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manuels-tavern",
      "poi_latitude": "33.7707382",
      "poi_longitude": "-84.35276859999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-525-3447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e74-779f-bd5c-7d00dfe69593.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e74-779f-bd5c-7d00dfe69593",
        "storage_key": "property/5656808622391296/019f1517-3e74-779f-bd5c-7d00dfe69593.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnbi7oqcG9YgRCp6paNceye4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_1950825fe016d027d38c05bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Murphy's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "997 Virginia Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Mainstay for refined American fare, baked goods (some custom-made), wine events & a popular brunch.",
      "poi_long_description": "Mainstay for refined American fare, baked goods (some custom-made), wine events & a popular brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-eae2-7383-9327-88c10687690a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-eae2-7383-9327-88c10687690a",
        "storage_key": "property/5656808622391296/019f1516-eae2-7383-9327-88c10687690a.webp",
        "width": 1280,
        "height": 809
      },
      "poi_business_url": "https://www.murphysatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11433467685914868326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "murphys-restaurant",
      "poi_latitude": "33.7820585",
      "poi_longitude": "-84.35473019999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-872-0904",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq7AKiCAE9YgRZvrcgUjWq54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_11eb66900908341d08df0322",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Publix Super Market at Cheshire Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "2325 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-f0ad-720c-bcf7-93e05bdc37f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-f0ad-720c-bcf7-93e05bdc37f0",
        "storage_key": "property/5656808622391296/019f1516-f0ad-720c-bcf7-93e05bdc37f0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1044&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=727285074775798436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-cheshire-square",
      "poi_latitude": "33.818479",
      "poi_longitude": "-84.34902129999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-638-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-790f-7792-b430-7a28cfe3ccc1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-790f-7792-b430-7a28cfe3ccc1",
        "storage_key": "property/5656808622391296/019f1515-790f-7792-b430-7a28cfe3ccc1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7zwLHQG9YgRpHJ0FOzVFwo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_5701e2d04859d31c8ced6c1b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1700 Monroe Dr NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-f061-71db-8384-3bc85bf770f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-f061-71db-8384-3bc85bf770f4",
        "storage_key": "property/5656808622391296/019f1516-f061-71db-8384-3bc85bf770f4.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/atlanta/ansley-mall/011/00298?cid=loc_01100298_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9561218542048904146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "33.8005047",
      "poi_longitude": "-84.37297219999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-872-0782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-790f-7792-b430-7a28cfe3ccc1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-790f-7792-b430-7a28cfe3ccc1",
        "storage_key": "property/5656808622391296/019f1515-790f-7792-b430-7a28cfe3ccc1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ10zeHTUE9YgR0gO0QptFsIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_d6c7d47c30a07599f5e8e35e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Mercado Acapulco Y Taqueria",
      "poi_type": "Shopping & Retail",
      "poi_address": "2179 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Casual eatery specializing in Mexican comfort food, including tacos, carnitas, and enchiladas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-f44e-714d-867f-cd9294d170b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-f44e-714d-867f-cd9294d170b6",
        "storage_key": "property/5656808622391296/019f1516-f44e-714d-867f-cd9294d170b6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7921715606781040341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercado-acapulco-y-taqueria",
      "poi_latitude": "33.81444140000001",
      "poi_longitude": "-84.3529787",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-477-3202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY_Z6x3cG9YgR1RbakV-W720",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_468001d450b293260ada5380",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2350 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-f17c-736b-a5ae-32e155e71e36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-f17c-736b-a5ae-32e155e71e36",
        "storage_key": "property/5656808622391296/019f1516-f17c-736b-a5ae-32e155e71e36.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/atlanta-ga-pharmacies/2350-cheshire-bridge-road-atlanta-ga-30324/storeid=2186?WT.mc_id=LS_GOOGLE_RX_2186",
      "poi_directions_map_url": "https://maps.google.com/?cid=4197130302962750222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.8189566",
      "poi_longitude": "-84.3519783",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-486-7289",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e80-71af-b11c-506134d2a9fb",
        "storage_key": "property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8TCs3UG9YgRDlMf8MUzPzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_b9c8e7722807762ee47cb7f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Atlanta City Compounding Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2212 Fellowship Rd, Tucker, GA 30084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-f506-73e3-9a35-44d383cca98d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-f506-73e3-9a35-44d383cca98d",
        "storage_key": "property/5656808622391296/019f1516-f506-73e3-9a35-44d383cca98d.webp",
        "width": 1280,
        "height": 1101
      },
      "poi_business_url": "http://www.rxacp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13138409629199532892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-city-compounding-pharmacy",
      "poi_latitude": "33.8491956",
      "poi_longitude": "-84.2184656",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 404-590-3785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e80-71af-b11c-506134d2a9fb",
        "storage_key": "property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZQHQ3QG9YgRXIMCjvIBVbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_32da8a91d4995281cf9917cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "AHF Pharmacy - Peachtree",
      "poi_type": "Shopping & Retail",
      "poi_address": "1438 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-f3d7-7269-ba6d-a4340377a618.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-f3d7-7269-ba6d-a4340377a618",
        "storage_key": "property/5656808622391296/019f1516-f3d7-7269-ba6d-a4340377a618.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://ahfpharmacy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17038347053401178898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ahf-pharmacy---peachtree",
      "poi_latitude": "33.793951",
      "poi_longitude": "-84.3884128",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-879-3990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e80-71af-b11c-506134d2a9fb",
        "storage_key": "property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWR851ME9YgREgPNPV9edOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_34400a131c4f4361cbccfdff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Citgo",
      "poi_type": "Shopping & Retail",
      "poi_address": "2239 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-f7d6-73a8-83b6-f44d45af2871.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-f7d6-73a8-83b6-f44d45af2871",
        "storage_key": "property/5656808622391296/019f1516-f7d6-73a8-83b6-f44d45af2871.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15007865354466700195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "citgo",
      "poi_latitude": "33.8162535",
      "poi_longitude": "-84.3522758",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-728-9533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e6f-7167-902b-9d08c456b5cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e6f-7167-902b-9d08c456b5cf",
        "storage_key": "property/5656808622391296/019f1517-3e6f-7167-902b-9d08c456b5cf.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSQjW3YG9YgRoyvhWQamRtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_ab3ffcbcceb97a39412b6eb4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "2319 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-f7b3-7254-b7a3-c631ec19bb58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-f7b3-7254-b7a3-c631ec19bb58",
        "storage_key": "property/5656808622391296/019f1516-f7b3-7254-b7a3-c631ec19bb58.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/atlanta/2319-cheshire-bridge-rd-ne/2655330?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7448881850652270368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "33.8180065",
      "poi_longitude": "-84.3513495",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-325-2328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e6f-7167-902b-9960688e9422.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e6f-7167-902b-9960688e9422",
        "storage_key": "property/5656808622391296/019f1517-3e6f-7167-902b-9960688e9422.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJoSrTgXYG9YgRIJ_7yZO-X2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_0b40bbbda46b7602b69efc08",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2539 Piedmont Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-f7cf-77dd-9abb-9cf56fa65878.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-f7cf-77dd-9abb-9cf56fa65878",
        "storage_key": "property/5656808622391296/019f1516-f7cf-77dd-9abb-9cf56fa65878.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.target.com/sl/buckhead-south/2171",
      "poi_directions_map_url": "https://maps.google.com/?cid=17503854957638649800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.8237498",
      "poi_longitude": "-84.36310089999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-720-1081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7901-7453-8c7a-e28e98bed6e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7901-7453-8c7a-e28e98bed6e3",
        "storage_key": "property/5656808622391296/019f1515-7901-7453-8c7a-e28e98bed6e3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpaoNAssF9YgRyAcDNlgv6vI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_13ad28bb38cc0cb857e792f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2525 Piedmont Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-fe0e-7289-9fe6-724bc21574c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-fe0e-7289-9fe6-724bc21574c8",
        "storage_key": "property/5656808622391296/019f1516-fe0e-7289-9fe6-724bc21574c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Buckhead/GA/Atlanta/30324/6986?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12782722657955998063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.8242191",
      "poi_longitude": "-84.36513509999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-841-5608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7901-7453-8c7a-e28e98bed6e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7901-7453-8c7a-e28e98bed6e3",
        "storage_key": "property/5656808622391296/019f1515-7901-7453-8c7a-e28e98bed6e3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE8T1osIF9YgRb-nNGYhaZbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_bc3155350a06280e85b5c267",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Morningside Elementary School",
      "poi_type": "Education",
      "poi_address": "1053 E Rock Springs Rd NE, Atlanta, GA 30306, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-fcda-7741-b783-8786e5ffd256.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-fcda-7741-b783-8786e5ffd256",
        "storage_key": "property/5656808622391296/019f1516-fcda-7741-b783-8786e5ffd256.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantapublicschools.us/Domain/1564",
      "poi_directions_map_url": "https://maps.google.com/?cid=11342087537425463530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morningside-elementary-school",
      "poi_latitude": "33.7972148",
      "poi_longitude": "-84.3527943",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-802-8950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaS4yk4EG9YgR6jiht4UwZ50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_e12ac81e985e7d6588bc4f85",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Rock Spring Kids Day Out",
      "poi_type": "Education",
      "poi_address": "1824 Piedmont Ave NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9940666588128313092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-spring-kids-day-out",
      "poi_latitude": "33.804574",
      "poi_longitude": "-84.367989",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-875-8270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy9vbUswF9YgRBH_7D5hX9Ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_b233833cdd76a830b0f8ad44",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Morningside Day Out",
      "poi_type": "Education",
      "poi_address": "2108 Briarcliff Rd NE, Atlanta, GA 30329, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-faa0-705a-84a2-27b65ec1ffd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-faa0-705a-84a2-27b65ec1ffd0",
        "storage_key": "property/5656808622391296/019f1516-faa0-705a-84a2-27b65ec1ffd0.webp",
        "width": 1280,
        "height": 582
      },
      "poi_business_url": "http://www.morningsidedayout.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15380805740425432372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morningside-day-out",
      "poi_latitude": "33.8151382",
      "poi_longitude": "-84.3355804",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-634-5889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ46urWkG9YgRNM1YdVSZc9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_c4698d61f65ffb4417e43ca7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Garden Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "285 Sheridan Dr NE, Atlanta, GA 30305, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.atlantapublicschools.us/gardenhills",
      "poi_directions_map_url": "https://maps.google.com/?cid=16546440758719238760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garden-hills-elementary-school",
      "poi_latitude": "33.8317513",
      "poi_longitude": "-84.3784113",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-802-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFwFjvpMF9YgRaFKBCDTEoOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_9016bac7c7734f89ce94cbb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Midtown High School",
      "poi_type": "Education",
      "poi_address": "929 Charles Allen Dr NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-fc14-735d-8a94-c2a793410b17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-fc14-735d-8a94-c2a793410b17",
        "storage_key": "property/5656808622391296/019f1516-fc14-735d-8a94-c2a793410b17.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantapublicschools.us/midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=18124944716900365978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-high-school",
      "poi_latitude": "33.7805714",
      "poi_longitude": "-84.3722454",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-802-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcTOFGj4E9YgRmnZwoDC9iPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_176348152cc4f13ee6e67cec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Emory University",
      "poi_type": "Education",
      "poi_address": "201 Dowman Dr, Atlanta, GA 30322, USA",
      "poi_short_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_long_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-115a-715a-ad47-6921b075a00b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-115a-715a-ad47-6921b075a00b",
        "storage_key": "property/5656808622391296/019f1515-115a-715a-ad47-6921b075a00b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.emory.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6401157007639682133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university",
      "poi_latitude": "33.7973735",
      "poi_longitude": "-84.3252791",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-727-6123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHU-KgPcG9YgRVZzdN2J61Vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_0a6ceba4fec9b9cce4b5bfff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Centennial Hall",
      "poi_type": "Education",
      "poi_address": "100 Auburn Ave NE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-fc65-7028-a005-9cc7263c12c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-fc65-7028-a005-9cc7263c12c9",
        "storage_key": "property/5656808622391296/019f1516-fc65-7028-a005-9cc7263c12c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://events.gsu.edu/centennial-hall/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11547083464942115314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-hall",
      "poi_latitude": "33.7558673",
      "poi_longitude": "-84.3837997",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-413-2063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsb8DWogD9YgR8lmpdzt7P6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "ec_8d3d36c0d38d20908f4c7e9b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Atlanta International School",
      "poi_type": "Education",
      "poi_address": "2890 N Fulton Dr NE, Atlanta, GA 30305, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-05da-706c-8a56-35ce8f8e8a26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-05da-706c-8a56-35ce8f8e8a26",
        "storage_key": "property/5656808622391296/019f1517-05da-706c-8a56-35ce8f8e8a26.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.aischool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8116433891789394436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-international-school",
      "poi_latitude": "33.8328593",
      "poi_longitude": "-84.37793640000001",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-841-3840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFWyrU5IF9YgRBFIMM59do3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_56f874a27077d6b14ebaead5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "The Paideia School",
      "poi_type": "Education",
      "poi_address": "1509 S Ponce De Leon Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-0371-71cb-98af-ff2a2cd69b70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-0371-71cb-98af-ff2a2cd69b70",
        "storage_key": "property/5656808622391296/019f1517-0371-71cb-98af-ff2a2cd69b70.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.paideiaschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10958705442548845046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-paideia-school",
      "poi_latitude": "33.7731723",
      "poi_longitude": "-84.3379362",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 404-377-3491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW61gqL4G9YgR9olDzYkkFZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_d374cf7ab7875bfa2a710893",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Atlanta Montessori International School - Cliff Valley",
      "poi_type": "Education",
      "poi_address": "1970 Cliff Valley Way NE, Atlanta, GA 30329, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-033c-767b-8ad1-8f52c2ebbde3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-033c-767b-8ad1-8f52c2ebbde3",
        "storage_key": "property/5656808622391296/019f1517-033c-767b-8ad1-8f52c2ebbde3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://amischool.com/locations/atlanta-montessori-international-school-cliff-valley/?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2785858284818632313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-montessori-international-school---cliff-valley",
      "poi_latitude": "33.8341351",
      "poi_longitude": "-84.3236459",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-325-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA_lFSSUG9YgReY4xlVlbqSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_a35c8e0afc62833b7ee847d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Skyline Park",
      "poi_type": "Entertainment",
      "poi_address": "Ponce City Market, 675 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Cheery place for games, rides & mini golf, plus beer & snacks, on the Ponce City Market roof.",
      "poi_long_description": "Cheery place for games, rides & mini golf, plus beer & snacks, on the Ponce City Market roof.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-0123-7049-8455-e212fb2b4483.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-0123-7049-8455-e212fb2b4483",
        "storage_key": "property/5656808622391296/019f1517-0123-7049-8455-e212fb2b4483.webp",
        "width": 1080,
        "height": 811
      },
      "poi_business_url": "https://poncecityroof.com/skyline-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10941119418121271072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skyline-park",
      "poi_latitude": "33.77282710000001",
      "poi_longitude": "-84.3655928",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-999-1530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp-YA7RAE9YgRIDc_aiSq1pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_c27fbd767a73eacccfefb401",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Variety Playhouse",
      "poi_type": "Entertainment",
      "poi_address": "1099 Euclid Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Converted movie theater now serves as an intimate concert hall featuring a variety of popular acts.",
      "poi_long_description": "Converted movie theater now serves as an intimate concert hall featuring a variety of popular acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-03ec-7761-ac4e-6a469ea6b0c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-03ec-7761-ac4e-6a469ea6b0c2",
        "storage_key": "property/5656808622391296/019f1517-03ec-7761-ac4e-6a469ea6b0c2.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.variety-playhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14554971689164868841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "variety-playhouse",
      "poi_latitude": "33.76372870000001",
      "poi_longitude": "-84.35107149999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 404-524-7354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8d2cqkG9YgR6QyKwKKl_ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_a26d5a2f2ba52461c196384b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Fox Theatre",
      "poi_type": "Entertainment",
      "poi_address": "660 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Restored opulent theater built in 1920s with 3,600-pipe organ hosts ballet, movies & other events.",
      "poi_long_description": "Restored opulent theater built in 1920s with 3,600-pipe organ hosts ballet, movies & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-076a-75ee-841e-7f0f7fa75d27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-076a-75ee-841e-7f0f7fa75d27",
        "storage_key": "property/5656808622391296/019f1517-076a-75ee-841e-7f0f7fa75d27.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "https://www.foxtheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1917821642260137630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-theatre",
      "poi_latitude": "33.7726136",
      "poi_longitude": "-84.3853395",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-285-8499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28DQdm8E9YgRnsZ4YZ94nRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_5205cafaee17313fecae773d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "High Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1280 Peachtree Rd NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Museum known for its diverse art collection & modern architecture by Richard Meier & Renzo Piano.",
      "poi_long_description": "Museum known for its diverse art collection & modern architecture by Richard Meier & Renzo Piano.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-0b64-754a-92bc-f648d5ce0f2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-0b64-754a-92bc-f648d5ce0f2f",
        "storage_key": "property/5656808622391296/019f1517-0b64-754a-92bc-f648d5ce0f2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.high.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17827694190187609074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "high-museum-of-art",
      "poi_latitude": "33.7900632",
      "poi_longitude": "-84.38555199999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-733-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79a6-7269-a5a0-16d58062b65f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79a6-7269-a5a0-16d58062b65f",
        "storage_key": "property/5656808622391296/019f1515-79a6-7269-a5a0-16d58062b65f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bUMEUE9YgR8nttKmmxaPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_e654126f3f52b29240943a4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Atlanta Botanical Garden",
      "poi_type": "Entertainment",
      "poi_address": "1345 Piedmont Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "30-acre garden with a conservatory & fountains playing host to concerts, cocktail parties & more.",
      "poi_long_description": "30-acre garden with a conservatory & fountains playing host to concerts, cocktail parties & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-5250-7573-9cbf-d249c770445b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-5250-7573-9cbf-d249c770445b",
        "storage_key": "property/5656808622391296/019f1515-5250-7573-9cbf-d249c770445b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11595354526965683893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-botanical-garden",
      "poi_latitude": "33.7899568",
      "poi_longitude": "-84.37259879999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-876-5859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RXVJTgE9YgRtdaB6IH56qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_80f1d07c1ef3f836b4905b9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Plaza Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1049 Ponce De Leon Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Independent movie theater showcases cult classics & midnight movies on Friday on the silver screen.",
      "poi_long_description": "Independent movie theater showcases cult classics & midnight movies on Friday on the silver screen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-0baf-7072-833f-40209604f57b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-0baf-7072-833f-40209604f57b",
        "storage_key": "property/5656808622391296/019f1517-0baf-7072-833f-40209604f57b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.plazaatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5819026170921268730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plaza-theatre",
      "poi_latitude": "33.7734567",
      "poi_longitude": "-84.3530406",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 470-410-1939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e83-778a-a548-76fcd7262fa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e83-778a-a548-76fcd7262fa9",
        "storage_key": "property/5656808622391296/019f1517-3e83-778a-a548-76fcd7262fa9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJP47X-6MG9YgR-rV20HhVwVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_b32afd39aa01e972f7925c25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Historic Fourth Ward Park",
      "poi_type": "Entertainment",
      "poi_address": "680 Dallas St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_long_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-0cd6-730b-8e13-fee0305341c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-0cd6-730b-8e13-fee0305341c2",
        "storage_key": "property/5656808622391296/019f1517-0cd6-730b-8e13-fee0305341c2.webp",
        "width": 1280,
        "height": 667
      },
      "poi_business_url": "http://www.h4wpc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1819443021458306877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-fourth-ward-park",
      "poi_latitude": "33.7694043",
      "poi_longitude": "-84.3647968",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 404-546-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7947-7139-8b8c-14004523f358",
        "storage_key": "property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSnz-A8E9YgRPfcVx8n1Pxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_d55fb9c3a93c079f43703815",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Center For Puppetry Arts",
      "poi_type": "Entertainment",
      "poi_address": "1404 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Long-standing puppetry museum with a variety of exhibits, performances, workshops & classes.",
      "poi_long_description": "Long-standing puppetry museum with a variety of exhibits, performances, workshops & classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-0e65-73dc-9a7f-dda63044527b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-0e65-73dc-9a7f-dda63044527b",
        "storage_key": "property/5656808622391296/019f1517-0e65-73dc-9a7f-dda63044527b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.puppet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8253606720874116330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-for-puppetry-arts",
      "poi_latitude": "33.792875",
      "poi_longitude": "-84.38985989999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-873-3391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4fRXllAE9YgR6nR6SZWzinI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_af3072775a3d232e251c6684",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Krog Street Market",
      "poi_type": "Entertainment",
      "poi_address": "99 Krog St NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Independent food stalls fill this market that was built in the 1920s & is now a popular hangout.",
      "poi_long_description": "Independent food stalls fill this market that was built in the 1920s & is now a popular hangout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-10bf-75dd-8cb0-5a4900cea5d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-10bf-75dd-8cb0-5a4900cea5d5",
        "storage_key": "property/5656808622391296/019f1517-10bf-75dd-8cb0-5a4900cea5d5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thekrogdistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10648318768682609403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krog-street-market",
      "poi_latitude": "33.756877",
      "poi_longitude": "-84.3641688",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-79bc-75e2-8727-4b3b8700a2df",
        "storage_key": "property/5656808622391296/019f1515-79bc-75e2-8727-4b3b8700a2df.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_RkHPPgD9YgR-6pzvoBtxpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_court"
    },
    {
      "id": "ec_67303e51dc7ba874380262f8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "The Masquerade",
      "poi_type": "Entertainment",
      "poi_address": "50 Lower Alabama Street #110, Atlanta, GA 30303, USA",
      "poi_short_description": "Nightclub has 3 main areas: Heaven (concert hall), Hell (DJ dance party) & Purgatory (a game room).",
      "poi_long_description": "Nightclub has 3 main areas: Heaven (concert hall), Hell (DJ dance party) & Purgatory (a game room).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-1188-7575-969b-fdaeaeb81f64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-1188-7575-969b-fdaeaeb81f64",
        "storage_key": "property/5656808622391296/019f1517-1188-7575-969b-fdaeaeb81f64.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://masqueradeatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=199848245662885103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-masquerade",
      "poi_latitude": "33.7516237",
      "poi_longitude": "-84.3898347",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 404-577-8178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1R3_hhoE9YgR76S4q-sAxgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_506f4b42fa5f6cc1f4cfa137",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Piedmont Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "1968 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-0fec-72ab-9526-f9fcb0bc3126.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-0fec-72ab-9526-f9fcb0bc3126",
        "storage_key": "property/5656808622391296/019f1517-0fec-72ab-9526-f9fcb0bc3126.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-atlanta?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY4MzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10361705813315035831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-atlanta",
      "poi_latitude": "33.8088868",
      "poi_longitude": "-84.394939",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-605-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7951-711c-9772-64c4bf8b922b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7951-711c-9772-64c4bf8b922b",
        "storage_key": "property/5656808622391296/019f1515-7951-711c-9772-64c4bf8b922b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ2L4-KkF9YgRtyK-3YkszI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_7da53fa871381a3230e21b83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Peachtree Immediate Care - Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "450 14th St NW, Atlanta, GA 30318, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-12ac-764f-b3da-ed991c3d0f1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-12ac-764f-b3da-ed991c3d0f1a",
        "storage_key": "property/5656808622391296/019f1517-12ac-764f-b3da-ed991c3d0f1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.peachtreemed.com/location/midtown/",
      "poi_directions_map_url": "https://maps.google.com/?cid=601517532570486055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peachtree-immediate-care---midtown",
      "poi_latitude": "33.7859572",
      "poi_longitude": "-84.4021827",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-480-9797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGdcc7vME9YgRJ4UIRwIFWQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_f19a8aef88fe7c3083a7b8d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2350 Cheshire Bridge Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-f17c-736b-a5ae-32e155e71e36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-f17c-736b-a5ae-32e155e71e36",
        "storage_key": "property/5656808622391296/019f1516-f17c-736b-a5ae-32e155e71e36.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/atlanta-ga-pharmacies/2350-cheshire-bridge-road-atlanta-ga-30324/storeid=2186?WT.mc_id=LS_GOOGLE_RX_2186",
      "poi_directions_map_url": "https://maps.google.com/?cid=4197130302962750222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.8189566",
      "poi_longitude": "-84.3519783",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-486-7289",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e80-71af-b11c-506134d2a9fb",
        "storage_key": "property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8TCs3UG9YgRDlMf8MUzPzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_26467240e523e2250fc57e23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "AHF Pharmacy - Peachtree",
      "poi_type": "Health and Wellness",
      "poi_address": "1438 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-f3d7-7269-ba6d-a4340377a618.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-f3d7-7269-ba6d-a4340377a618",
        "storage_key": "property/5656808622391296/019f1516-f3d7-7269-ba6d-a4340377a618.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://ahfpharmacy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17038347053401178898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ahf-pharmacy---peachtree",
      "poi_latitude": "33.793951",
      "poi_longitude": "-84.3884128",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-879-3990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e80-71af-b11c-506134d2a9fb",
        "storage_key": "property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWR851ME9YgREgPNPV9edOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_19bb2aeebc5f8b7eb651e861",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Walgreens Specialty Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1874 Piedmont Ave NE #100A, Atlanta, GA 30324, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-1513-75be-bf69-5d61886f5d7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-1513-75be-bf69-5d61886f5d7d",
        "storage_key": "property/5656808622391296/019f1517-1513-75be-bf69-5d61886f5d7d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1874+piedmont+ave+ne-atlanta-ga-30324/id=15304",
      "poi_directions_map_url": "https://maps.google.com/?cid=13081576115456394296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-specialty-pharmacy",
      "poi_latitude": "33.8075967",
      "poi_longitude": "-84.3665631",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-733-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e80-71af-b11c-506134d2a9fb",
        "storage_key": "property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-4D67u4F9YgROEQD-CoYi7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_869a5f0dee52461be176b753",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Publix Pharmacy at Ansley Mall",
      "poi_type": "Health and Wellness",
      "poi_address": "1544 Piedmont Ave NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-1446-72bb-8579-56ac930af9e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-1446-72bb-8579-56ac930af9e2",
        "storage_key": "property/5656808622391296/019f1517-1446-72bb-8579-56ac930af9e2.webp",
        "width": 1280,
        "height": 955
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=9024537228654326231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-ansley-mall",
      "poi_latitude": "33.7990702",
      "poi_longitude": "-84.3717877",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-724-0932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e80-71af-b11c-506134d2a9fb",
        "storage_key": "property/5656808622391296/019f1517-3e80-71af-b11c-506134d2a9fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6aWVaDQE9YgR17E6oMuYPX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_8c72e6947704112f12b7b8cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1544 Piedmont Ave NE Ste 115, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-3fec-768a-be12-97d1d43be155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-3fec-768a-be12-97d1d43be155",
        "storage_key": "property/5656808622391296/019f1515-3fec-768a-be12-97d1d43be155.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=153&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17997456363253407001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.7980064",
      "poi_longitude": "-84.3711202",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-249-6463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6aWVaDQE9YgRGR1QMDXPw_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_3192e445358b0b3c6f5b9a85",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "933 Peachtree St NE #939A, Atlanta, GA 30309, USA",
      "poi_short_description": "Group, treadmill-based workout studio, featuring certified instructors and fitness training in an energetic environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-1add-74b4-a57d-a1c376826316.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-1add-74b4-a57d-a1c376826316",
        "storage_key": "property/5656808622391296/019f1517-1add-74b4-a57d-a1c376826316.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/atlanta-georgia-0137?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=621678546688391647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "33.780276",
      "poi_longitude": "-84.3839747",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-747-7107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWpDnUIE9YgR37nXK1iloAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ba3bcbcd41026a9af9b936ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Body & Brain Yoga Tai Chi",
      "poi_type": "Health and Wellness",
      "poi_address": "4641 Roswell Rd Ste C, Atlanta, GA 30342, USA",
      "poi_short_description": "Yoga and tai chi studio offering classes and workshops featuring holistic wellness training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-170b-717d-88b2-5baaa3908deb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-170b-717d-88b2-5baaa3908deb",
        "storage_key": "property/5656808622391296/019f1517-170b-717d-88b2-5baaa3908deb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.bodynbrain.com/buckhead",
      "poi_directions_map_url": "https://maps.google.com/?cid=6623028828577933881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "body--brain-yoga-tai-chi",
      "poi_latitude": "33.881633",
      "poi_longitude": "-84.3794618",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 404-252-1881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl4VllhQP9YgROSqPGKG56Vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_f373ea6e0eaeeae33780484c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Highland Yoga - Virginia Highland",
      "poi_type": "Health and Wellness",
      "poi_address": "842 N Highland Ave NE #5, Atlanta, GA 30306, USA",
      "poi_short_description": "Modern yoga studio offering Vinyasa classes in a heated practice room with a serene vibe.",
      "poi_long_description": "Modern yoga studio offering Vinyasa classes in a heated practice room with a serene vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-1894-75bf-80f8-3ccd3f4abc42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-1894-75bf-80f8-3ccd3f4abc42",
        "storage_key": "property/5656808622391296/019f1517-1894-75bf-80f8-3ccd3f4abc42.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.highland-yoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16311819849066424679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highland-yoga---virginia-highland",
      "poi_latitude": "33.7775098",
      "poi_longitude": "-84.3529432",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-343-2311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdac2aqAG9YgRZynFn7o5X-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_242f93459b6aacfd83749767",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Morningside Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Parking lot, 2020 Lenox Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "This forested tract with paths for running, hiking & biking also features a scenic creek.",
      "poi_long_description": "This forested tract with paths for running, hiking & biking also features a scenic creek.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-1ad5-7526-a6b5-91950603479a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-1ad5-7526-a6b5-91950603479a",
        "storage_key": "property/5656808622391296/019f1517-1ad5-7526-a6b5-91950603479a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantatrails.com/hiking-trails/morningside-nature-preserve-atlanta-walking-and-running-trails/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17129916476235206221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morningside-nature-preserve",
      "poi_latitude": "33.8099025",
      "poi_longitude": "-84.3520896",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-546-6788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7947-7139-8b8c-14004523f358",
        "storage_key": "property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOaQzM9QF9YgRTU4c5kawue0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_83300dca22a566bc2b1a5f14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Armand Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2177 Armand Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-1a7d-749e-80a6-62f160c64217.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-1a7d-749e-80a6-62f160c64217",
        "storage_key": "property/5656808622391296/019f1517-1a7d-749e-80a6-62f160c64217.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2390609507578848146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armand-park",
      "poi_latitude": "33.8145105",
      "poi_longitude": "-84.3598435",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-546-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7947-7139-8b8c-14004523f358",
        "storage_key": "property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4nFffUF9YgRkqPoX64mLSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_80198f175f4728d36255670c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Daniel Johnson Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Daniel Johnson Nature Preserve, 1301 Beech Valley Rd NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Tranquil green space with a creek & a network of unpaved trails shaded by mature trees.",
      "poi_long_description": "Tranquil green space with a creek & a network of unpaved trails shaded by mature trees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-21de-7527-9f7a-534f08993404.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-21de-7527-9f7a-534f08993404",
        "storage_key": "property/5656808622391296/019f1517-21de-7527-9f7a-534f08993404.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.atlantaga.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3980563101794690201&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daniel-johnson-nature-preserve",
      "poi_latitude": "33.7971288",
      "poi_longitude": "-84.342702",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-546-6788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7947-7139-8b8c-14004523f358",
        "storage_key": "property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7TSlYgG9YgRmeR_GA3NPTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_746d0344a0e87fbf7652770e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Herbert Taylor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1795 Johnson Rd NE, Atlanta, GA 30306, USA",
      "poi_short_description": "This wooded park bisected by a creek is dog-friendly & features a variety of wildlife.",
      "poi_long_description": "This wooded park bisected by a creek is dog-friendly & features a variety of wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-1c6d-7039-8f15-1b867a17558d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-1c6d-7039-8f15-1b867a17558d",
        "storage_key": "property/5656808622391296/019f1517-1c6d-7039-8f15-1b867a17558d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=37110467654714293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "herbert-taylor-park",
      "poi_latitude": "33.8004285",
      "poi_longitude": "-84.3408157",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-546-6742",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7947-7139-8b8c-14004523f358",
        "storage_key": "property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxAMN4gG9YgRtQMCEsbXgwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_90ebf5e7e0965dd2e0aa7671",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Lenox-Wildwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1760 Lenox Rd NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Park with a playground and swings, plus tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-23f0-72d0-b3f6-f1627aac0d3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-23f0-72d0-b3f6-f1627aac0d3d",
        "storage_key": "property/5656808622391296/019f1517-23f0-72d0-b3f6-f1627aac0d3d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10300218207937364286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenox-wildwood-park",
      "poi_latitude": "33.8005447",
      "poi_longitude": "-84.3527261",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-546-6788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7947-7139-8b8c-14004523f358",
        "storage_key": "property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz31EDYAG9YgRPgEeIeO58Y4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_cfcca3c3613a1e34b1224227",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Sunken Garden Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30306, USA",
      "poi_short_description": "Small neighborhood park featuring swings, slides, a fire pit and playground equipment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-2381-712d-bc95-3513ecc7a2bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-2381-712d-bc95-3513ecc7a2bb",
        "storage_key": "property/5656808622391296/019f1517-2381-712d-bc95-3513ecc7a2bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8627540498906534967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunken-garden-park",
      "poi_latitude": "33.7979347",
      "poi_longitude": "-84.3546157",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7947-7139-8b8c-14004523f358",
        "storage_key": "property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuXa5cCoE9YgRN9Segl8uu3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6eab640c94d98d8b8af0d6fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Noble Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1715 Meadowdale Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1989504573102644808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noble-park",
      "poi_latitude": "33.8014847",
      "poi_longitude": "-84.3447563",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7947-7139-8b8c-14004523f358",
        "storage_key": "property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8_XH0G9YgRSF7MTt4jnBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7d5520edf2b97a67536f448f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Zonolite Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1164 Zonolite Pl NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Reclaimed wooded area set on a former industrial waste site, with trails, a pond, creek & wildlife.",
      "poi_long_description": "Reclaimed wooded area set on a former industrial waste site, with trails, a pond, creek & wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-2318-7017-a55d-49561403bcc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-2318-7017-a55d-49561403bcc7",
        "storage_key": "property/5656808622391296/019f1517-2318-7017-a55d-49561403bcc7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://southforkconservancy.org/zonolite/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10224889946266448411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zonolite-park",
      "poi_latitude": "33.8055884",
      "poi_longitude": "-84.3420608",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7947-7139-8b8c-14004523f358",
        "storage_key": "property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIwFiu3wG9YgRG7Ksejsb5o0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_61599185cfd423b6d6ee45f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Piedmont Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_long_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-3f79-727e-92d0-879c5c5958ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-3f79-727e-92d0-879c5c5958ab",
        "storage_key": "property/5656808622391296/019f1515-3f79-727e-92d0-879c5c5958ab.webp",
        "width": 736,
        "height": 485
      },
      "poi_business_url": "https://piedmontpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17559229622006002958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-park",
      "poi_latitude": "33.7879265",
      "poi_longitude": "-84.37216819999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7947-7139-8b8c-14004523f358",
        "storage_key": "property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaxkUDkE9YgRDjUv9U7qrvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7dc9bb0ff3943491316e425e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "LaVista Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1319 Brook Forest Dr NE, Atlanta, GA 30324, USA",
      "poi_short_description": "Wooded open space featuring a trail alongside a creek as well as a playground for kids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-2777-779c-b70a-1855def1f448.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-2777-779c-b70a-1855def1f448",
        "storage_key": "property/5656808622391296/019f1517-2777-779c-b70a-1855def1f448.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lavistapark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8162999904421506858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lavista-park",
      "poi_latitude": "33.8177445",
      "poi_longitude": "-84.3408942",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-825-4017",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7947-7139-8b8c-14004523f358",
        "storage_key": "property/5656808622391296/019f1515-7947-7139-8b8c-14004523f358.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnfj-KmwG9YgRKm-X5CnNSHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4f4be2578f3b8f147d86651f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Lindbergh Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "2424 Piedmont Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-6897-72e8-b9df-5980ec9bc4ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-6897-72e8-b9df-5980ec9bc4ac",
        "storage_key": "property/5656808622391296/019f1515-6897-72e8-b9df-5980ec9bc4ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Lindbergh.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=632507744447004235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lindbergh-center",
      "poi_latitude": "33.8231157",
      "poi_longitude": "-84.36943869999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo8oZEMIF9YgRS35yQXEexwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_f667e677decc8efb22ba9f05",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Inman Park / Reynoldstown",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30307, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-2a7c-71fc-8cb1-f751fd45aa28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-2a7c-71fc-8cb1-f751fd45aa28",
        "storage_key": "property/5656808622391296/019f1517-2a7c-71fc-8cb1-f751fd45aa28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.itsmarta.com/Inman-Park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6131164905906579969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "inman-park--reynoldstown",
      "poi_latitude": "33.7577002",
      "poi_longitude": "-84.3525767",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzs5yaoG9YgRASrnY_9FFlU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_b8ad3ba39f7f6f93a150415e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Midtown",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-2c70-70cd-b86b-ec7865bbe13b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-2c70-70cd-b86b-ec7865bbe13b",
        "storage_key": "property/5656808622391296/019f1517-2c70-70cd-b86b-ec7865bbe13b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Midtown.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3874113686536918320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown",
      "poi_latitude": "33.7811234",
      "poi_longitude": "-84.38634379999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdym9WF0E9YgRMBWDOd-dwzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_0d35a3a620ccd3a3d037280b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Arts Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-5b44-73c8-9d70-4377712a161a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-5b44-73c8-9d70-4377712a161a",
        "storage_key": "property/5656808622391296/019f1515-5b44-73c8-9d70-4377712a161a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.itsmarta.com/Arts-Center.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6693853067366476356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arts-center",
      "poi_latitude": "33.7892135",
      "poi_longitude": "-84.38734",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6XSS4FoE9YgRRKoJM-ZX5Vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_2bae0dc3593804fb991115bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Edgewood-Candler Park Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30307, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-2d36-73e9-a5be-341c2e272b8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-2d36-73e9-a5be-341c2e272b8d",
        "storage_key": "property/5656808622391296/019f1517-2d36-73e9-a5be-341c2e272b8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Edgewood-Candler-Park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=17196389103369244162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edgewood-candler-park-station",
      "poi_latitude": "33.7619503",
      "poi_longitude": "-84.3397062",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf36v3rMG9YgRAs64dcfYpe4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_50f3b9533c05d9be81dce0af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Magnolia Hall",
      "poi_type": "Transportation & Transit",
      "poi_address": "1320 Monroe Dr NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Concert hall for candlelight tributes to musicians in a beautiful space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-2c13-7758-8a95-e2d4beef958c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-2c13-7758-8a95-e2d4beef958c",
        "storage_key": "property/5656808622391296/019f1517-2c13-7758-8a95-e2d4beef958c.webp",
        "width": 1280,
        "height": 1279
      },
      "poi_business_url": "https://piedmontpark.org/venue/magnolia-hall/?eventDisplay=past",
      "poi_directions_map_url": "https://maps.google.com/?cid=16009479594287660339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "magnolia-hall",
      "poi_latitude": "33.78831480000001",
      "poi_longitude": "-84.3728766",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7mQtDgE9YgRM31hgN4YLd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_9880b86e840aadc1afab5699",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Five points marta station",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 Alabama St SW, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-30cf-774e-98d4-f544e8c5f7d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-30cf-774e-98d4-f544e8c5f7d6",
        "storage_key": "property/5656808622391296/019f1517-30cf-774e-98d4-f544e8c5f7d6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9456548135659215659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-points-marta-station",
      "poi_latitude": "33.7539909",
      "poi_longitude": "-84.391697",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV048YwAJ9YgRK5tZK21oPIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_540f0aea00cadda729043fad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-2f2d-708c-86ba-fef3740cbfd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-2f2d-708c-86ba-fef3740cbfd2",
        "storage_key": "property/5656808622391296/019f1517-2f2d-708c-86ba-fef3740cbfd2.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "16.7 mi",
      "poi_walking_minutes": "6 hours 17 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7e63-719b-82b5-20c25552168e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7e63-719b-82b5-20c25552168e",
        "storage_key": "property/5656808622391296/019f1515-7e63-719b-82b5-20c25552168e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_f6557576c511df0aff2f831b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Emory University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 Dowman Dr, Atlanta, GA 30322, USA",
      "poi_short_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_long_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-115a-715a-ad47-6921b075a00b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-115a-715a-ad47-6921b075a00b",
        "storage_key": "property/5656808622391296/019f1515-115a-715a-ad47-6921b075a00b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.emory.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6401157007639682133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university",
      "poi_latitude": "33.7973735",
      "poi_longitude": "-84.3252791",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-727-6123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHU-KgPcG9YgRVZzdN2J61Vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_f83d8df0734c81c0a42282f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Emory University Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1364 Clifton Rd NE, Atlanta, GA 30322, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-346d-7654-a17d-0c9ca5c2a786.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-346d-7654-a17d-0c9ca5c2a786",
        "storage_key": "property/5656808622391296/019f1517-346d-7654-a17d-0c9ca5c2a786.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.emoryhealthcare.org/locations/hospitals/emory-university-hospital?&utm_campaign=brand_euh_ra_gmb-locations&utm_source=google&utm_medium=gmb&utm_content=gmb_locations?&utm_campaign=brand_all_non&utm_source=google&utm_medium=gmb&utm_content=gmb-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=5349286101784653886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university-hospital",
      "poi_latitude": "33.7917965",
      "poi_longitude": "-84.3197392",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-712-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7951-711c-9772-64c4bf8b922b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7951-711c-9772-64c4bf8b922b",
        "storage_key": "property/5656808622391296/019f1515-7951-711c-9772-64c4bf8b922b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyYqdV_oG9YgRPvDOKl57PEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_042dff898f78fd627d7a6a09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Emory University Hospital Midtown",
      "poi_type": "Major Employers & Offices",
      "poi_address": "550 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-4890-7640-b0af-e89d765f1481.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-4890-7640-b0af-e89d765f1481",
        "storage_key": "property/5656808622391296/019f1515-4890-7640-b0af-e89d765f1481.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.emoryhealthcare.org/locations/hospitals/emory-university-hospital-midtown?&utm_campaign=brand_euh_ra_gmb-locations&utm_source=google&utm_medium=gmb&utm_content=gmb_locations?&utm_campaign=brand_all_non&utm_source=google&utm_medium=gmb&utm_content=gmb-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=15043808532116501154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university-hospital-midtown",
      "poi_latitude": "33.7686442",
      "poi_longitude": "-84.38619290000001",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 404-686-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7951-711c-9772-64c4bf8b922b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7951-711c-9772-64c4bf8b922b",
        "storage_key": "property/5656808622391296/019f1515-7951-711c-9772-64c4bf8b922b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42AWonoE9YgRonLLiSdYxtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_bb19898c6d9f86f376728d8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Children's Healthcare of Atlanta - Egleston Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1405 Clifton Rd NE, Atlanta, GA 30322, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-343a-730b-9c64-416bca51248e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-343a-730b-9c64-416bca51248e",
        "storage_key": "property/5656808622391296/019f1517-343a-730b-9c64-416bca51248e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.choa.org/locations/egleston-hospital?cid=_na1_ch-Yx_na3_na4_d-yxll_na6",
      "poi_directions_map_url": "https://maps.google.com/?cid=10949268201800251684&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-healthcare-of-atlanta---egleston-hospital",
      "poi_latitude": "33.7934917",
      "poi_longitude": "-84.3195325",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-785-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR4J4LPoG9YgRJLnI9mqd85c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_61047a00c5ce0d314f0d0a9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Centers for Disease Control and Prevention",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Clifton Rd NE, Atlanta, GA 30333, USA",
      "poi_short_description": "This federal facility for the prevention & spread of diseases offers exhibits at its nearby museum.",
      "poi_long_description": "This federal facility for the prevention & spread of diseases offers exhibits at its nearby museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-35f8-758b-a32c-8c206eb9b4ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-35f8-758b-a32c-8c206eb9b4ac",
        "storage_key": "property/5656808622391296/019f1517-35f8-758b-a32c-8c206eb9b4ac.webp",
        "width": 971,
        "height": 1280
      },
      "poi_business_url": "https://www.cdc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1310566027616466354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centers-for-disease-control-and-prevention",
      "poi_latitude": "33.799329",
      "poi_longitude": "-84.32858999999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-639-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-3e77-7559-85ee-a5af59c03b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-3e77-7559-85ee-a5af59c03b45",
        "storage_key": "property/5656808622391296/019f1517-3e77-7559-85ee-a5af59c03b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsx8GO3oE9YgRsjXGwtsQMBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_b72b6e3f4c529d41d0a51713",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Piedmont Atlanta",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1968 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1517-0fec-72ab-9526-f9fcb0bc3126.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-0fec-72ab-9526-f9fcb0bc3126",
        "storage_key": "property/5656808622391296/019f1517-0fec-72ab-9526-f9fcb0bc3126.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-atlanta?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY4MzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10361705813315035831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-atlanta",
      "poi_latitude": "33.8088868",
      "poi_longitude": "-84.394939",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-605-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7951-711c-9772-64c4bf8b922b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7951-711c-9772-64c4bf8b922b",
        "storage_key": "property/5656808622391296/019f1515-7951-711c-9772-64c4bf8b922b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ2L4-KkF9YgRtyK-3YkszI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_c086368d0c1ae28daa536877",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Grady Memorial Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "80 Jesse Hill Jr Dr SE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-3cb6-7325-9148-aeec99717205.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-3cb6-7325-9148-aeec99717205",
        "storage_key": "property/5656808622391296/019f1515-3cb6-7325-9148-aeec99717205.webp",
        "width": 1200,
        "height": 400
      },
      "poi_business_url": "https://www.gradyhealth.org/?utm_source=gmb&utm_medium=organic&utm_campaign=sitelink&utm_id=grady",
      "poi_directions_map_url": "https://maps.google.com/?cid=7804908829099084763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grady-memorial-hospital",
      "poi_latitude": "33.7517368",
      "poi_longitude": "-84.3821134",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 404-616-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7951-711c-9772-64c4bf8b922b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7951-711c-9772-64c4bf8b922b",
        "storage_key": "property/5656808622391296/019f1515-7951-711c-9772-64c4bf8b922b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Rc8z44D9YgR28vCVjqbUGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_66e564adc3ec12973781dba8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Georgia Institute of Technology",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Atlanta, GA 30332, USA",
      "poi_short_description": "This urban research university founded in 1885 is known for engineering, science & business.",
      "poi_long_description": "This urban research university founded in 1885 is known for engineering, science & business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-13c6-7446-b758-5f9fc27a5b67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-13c6-7446-b758-5f9fc27a5b67",
        "storage_key": "property/5656808622391296/019f1515-13c6-7446-b758-5f9fc27a5b67.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13054475435580638479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-institute-of-technology",
      "poi_latitude": "33.7779791",
      "poi_longitude": "-84.3979638",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-894-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ40_D64oE9YgRD8XYOj7QKrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_f3a645ee79fd443bb11a6d7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "One Coca-Cola Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "528 Luckie St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-6a1b-7039-b69a-db2731dce400.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-6a1b-7039-b69a-db2731dce400",
        "storage_key": "property/5656808622391296/019f1515-6a1b-7039-b69a-db2731dce400.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.coca-colacompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12947067275745438064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-coca-cola-plaza",
      "poi_latitude": "33.7711478",
      "poi_longitude": "-84.397268",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-676-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-796c-726b-b19f-9ad589f36bfe",
        "storage_key": "property/5656808622391296/019f1515-796c-726b-b19f-9ad589f36bfe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv5ISQokD9YgRcCnkPRc5rbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_90419616a4afedbfa25ea2d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "poi_name": "Centennial Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Auburn Ave NE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1516-fc65-7028-a005-9cc7263c12c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1516-fc65-7028-a005-9cc7263c12c9",
        "storage_key": "property/5656808622391296/019f1516-fc65-7028-a005-9cc7263c12c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://events.gsu.edu/centennial-hall/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11547083464942115314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-hall",
      "poi_latitude": "33.7558673",
      "poi_longitude": "-84.3837997",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-413-2063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-7966-7127-b459-92d179382e1a",
        "storage_key": "property/5656808622391296/019f1515-7966-7127-b459-92d179382e1a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsb8DWogD9YgR8lmpdzt7P6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    }
  ],
  "office_hours": [
    {
      "id": "ec_956ae6f5a48fb9aa71f4a72a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1636979e614638030a39e9aa",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_8ca79212cd64341fcb9fdb98",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c7cf24e38b45186b32f16022",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_49ea055ce58d969a0a3cf719",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7c07643da1aefe4667c396c7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_a52b74e8c680ea3e834d17ed",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "rating": "5",
      "name": "Alexis W",
      "text": "I’m very happy with 2050 Morningside. I had a hiccup when moving in that was promptly addressed and the one time I needed maintenance they responded quickly. Anthony, Ana, and Quinn have provided great customer service and the property itself is maintained and well kept. I love the property and have enjoyed the few months I have lived here.",
      "date": "2026-01-24",
      "title": "false"
    },
    {
      "id": "ec_2a96a857de768e30f8d09c3c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "rating": "5",
      "name": "S Covington",
      "text": "From my first tour to signing my lease Rodriquez has been exceptionally helpful and professional throughout the process. I was only looking at 1 unit and he went out his way to show me two additional units to give me more options, he responds in a timely manor to calls and emails. Rodriquez made sure the move in process was smooth and went over every detail with the breakdown of costs.\n\nThe property is small and quiet (mostly) it has its moment around holidays, I moved in back in September of 2023 it’s it’s been nice so far I’d recommend this place to friends and family",
      "date": "2024-01-08",
      "title": "false"
    },
    {
      "id": "ec_3436589f525bc68e9b6a7641",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "rating": "5",
      "name": "Chyna Turner",
      "text": "They solve all of my problems, swiftly, and are really nice people. If I wanted to choose between living outside the heart of the city but not too far with dashing affordability, this place would be ideal. Unfortunately, my business has to keep me local within midtown, so I couldn’t stay long. However, the units are spacious, and more renovated than others. I really loved my closet and kitchen.",
      "date": "2025-08-11",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_9c9589f120f24168291c9a41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f14c4-c787-73d2-a027-47e6878a9c72.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-c787-73d2-a027-47e6878a9c72",
        "storage_key": "property/5656808622391296/019f14c4-c787-73d2-a027-47e6878a9c72.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,081SF (B1)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4BSTXqHr5Qh"
    },
    {
      "id": "ec_4751337b2e45aca5f5d50e8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f14c4-c767-702a-93bc-2c6d2d328195.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-c767-702a-93bc-2c6d2d328195",
        "storage_key": "property/5656808622391296/019f14c4-c767-702a-93bc-2c6d2d328195.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=saaKJxpnJV4"
    },
    {
      "id": "ec_66cef0d06cd5cb9439427381",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f14c4-c8e8-76f9-8fdc-e610fb485271.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-c8e8-76f9-8fdc-e610fb485271",
        "storage_key": "property/5656808622391296/019f14c4-c8e8-76f9-8fdc-e610fb485271.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KDRpnZUWnBs"
    },
    {
      "id": "ec_28d700c9cc98d825ec52794b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f14c4-d0be-7179-abe0-492f454620e1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-d0be-7179-abe0-492f454620e1",
        "storage_key": "property/5656808622391296/019f14c4-d0be-7179-abe0-492f454620e1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sky Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Y935FpG74yD"
    }
  ],
  "faqs": [
    {
      "id": "custom_9d2132af-989e-47f2-989d-435ecffd890e",
      "question": "Is 2050 Morningside pet-friendly?",
      "answer": "Yes. 2050 Morningside is a pet-friendly community and welcomes both cats and dogs. We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply. Contact us for more information. For the full pet policy and any questions about your specific pet, call the leasing team at (770) 299-2503 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_414e89aa-4482-4b15-9201-15475d047b5d",
      "question": "How can I schedule a tour at 2050 Morningside?",
      "answer": "Scheduling a tour of 2050 Morningside is easy. Book online through our Schedule a Tour page or call the leasing office at (770) 299-2503. Prefer to explore from home first? Take a look at our virtual tours to see the community before you visit.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_2ebadc42-9eed-4d28-ac4e-02dd2f6036ec",
      "question": "What are the leasing office hours at 2050 Morningside?",
      "answer": "The 2050 Morningside leasing office is open during the following hours:\n• Monday: 9:00 AM - 6:00 PM\n• Tuesday: 9:00 AM - 6:00 PM\n• Wednesday: 9:00 AM - 6:00 PM\n• Thursday: 9:00 AM - 6:00 PM\n• Friday: 9:00 AM - 6:00 PM\n• Saturday: 10:00 AM - 5:00 PM\n• Sunday: Closed\n\nHours can change around holidays — call (770) 299-2503 or visit our contact page to confirm before you stop by.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_5d26613b-62a5-4419-9fd2-43bfa4cc2bfc",
      "question": "What floor plans are available at 2050 Morningside?",
      "answer": "2050 Morningside offers 1 to 2-bedroom apartment homes ranging from roughly 657–1151 square feet. With 13 distinct floor plans to choose from, there's a layout to fit how you live. Explore layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_b0e1d459-e71c-4e24-827a-1b3773532f48",
      "question": "What amenities does 2050 Morningside have?",
      "answer": "2050 Morningside pairs resort-style community amenities with well-appointed apartment interiors. Community amenities include: American Landmark 360 Resident Program, Gourmet Coffee Bar, Resident Courtyard, 24-Hour Fitness Center, Convenient 24/7 Online Resident Services, 24-Hour Resident Package System, Resort-Style Pool, Sky Lounge, Complimentary Wine Tap, Bike Storage and Repair Area. In-home features include: Quartz or Marble Countertops, Garden Tubs & Walk-In Showers, Wood Style Flooring, Stainless Steel Appliances, Deep, Single-Basin Sinks, In-Home Washer and Dryers. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_7ebf72fb-81c6-4ad8-bc90-b1fef4073dee",
      "question": "Where is 2050 Morningside located?",
      "answer": "2050 Morningside is located at 2050 Cheshire Bridge Rd NE, Atlanta, GA, 30324. You'll find dining like The Colonnade, shopping at Publix Super Market at Cheshire Square, green space at Morningside Nature Preserve nearby. Explore everything around the community on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_d1a2147e-6a2a-42ac-8a6e-852e2e5deb1f",
      "question": "How do I apply to live at 2050 Morningside?",
      "answer": "You can apply to live at 2050 Morningside online through our Apply Now page. The application walks you through the steps to reserve your apartment home. If you have questions along the way, the leasing team is happy to help — call (770) 299-2503 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_36aa1192-1715-47f6-a972-05dce92385f8",
      "question": "What do I need to apply at 2050 Morningside?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Specific qualification requirements can vary, so we recommend confirming the current criteria with the 2050 Morningside leasing team at (770) 299-2503 or on our contact page before you apply. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_59881d9b-b54b-4393-ac95-dfed80988989",
      "question": "What is the Landmark 360 program at 2050 Morningside?",
      "answer": "The Landmark 360 Resident Program at 2050 Morningside is American Landmark's signature commitment to resident satisfaction. It includes three promises: (1) The Move-In Satisfaction Promise — if you're not 100% satisfied within your first 15 days, we'll refund your deposit and waive termination fees. (2) The 48-Hour Maintenance Completion Promise — all standard work orders submitted Monday through Friday are completed within 48 hours, with rent credits issued for qualifying delays. (3) The Hassle-Free Relocation Promise — after six months on your lease, you can transfer to another American Landmark community without penalties by providing 60 days' written notice. Contact our leasing office for full program details.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_0b9b6c2d-c351-4072-976b-b8d1958fbac1",
      "question": "Does 2050 Morningside have a pool?",
      "answer": "Yes. 2050 Morningside features a resort-style swimming pool for residents to relax and unwind. See it alongside our other community amenities on the Amenities page, or take a look inside our virtual tour of the pool.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_ec0e7ae9-b0c2-438a-b3b7-603bb2f0d1de",
      "question": "Does 2050 Morningside have a fitness center?",
      "answer": "Yes. 2050 Morningside has a 24-hour fitness center so you can work out on your own schedule. Explore all of our amenities on the Amenities page or schedule a tour to check it out in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_eaff0c60-ac5c-43c0-964d-786f9b227fd0",
      "question": "Does 2050 Morningside offer virtual tours?",
      "answer": "Yes. 2050 Morningside offers virtual tours so you can explore the community from anywhere. Tours available include: 2BR, 2BA - 1,081SF (B1), Fitness Center, Pool, Sky Lounge. Start exploring on our Virtual Tours page, then schedule an in-person tour when you're ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_72406c75-4565-41f9-8037-adffb6325407",
      "question": "What schools are near 2050 Morningside?",
      "answer": "Several schools and educational institutions are near 2050 Morningside, including:\n• Morningside Elementary School — 1.6 mi away\n• Midtown High School — 2.9 mi away\n• Emory University — 3.2 mi away\n\nSee more nearby points of interest on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_66af0a08-d182-46b5-bc44-dbfa66c023e5",
      "question": "What do residents say about living at 2050 Morningside?",
      "answer": "Residents consistently highlight the community, helpful staff, and responsive maintenance at 2050 Morningside. One resident shared: \"So far I have only praises for this place: comfort, location, community, management, it's a great place to live.\" Read more resident experiences on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_439def25-7e70-4dcc-801c-c15a0c0373f1",
      "question": "When was 2050 Morningside built?",
      "answer": "2050 Morningside was built in 2019 and renovated in 2022, offering modern, established apartment living in Atlanta. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_1b461875-f525-4ce2-a1d5-50004faf6b1e",
      "question": "What is the pet fee at 2050 Morningside?",
      "answer": "Here's what to know about pets at 2050 Morningside: We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply. Contact us for more information. For details specific to your pet, contact the leasing team at (770) 299-2503 or via our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_61a4767e-f13c-4e01-895e-0dadf8fc6e4d",
      "question": "What features are included in the apartments at 2050 Morningside?",
      "answer": "Apartment homes at 2050 Morningside are designed with comfort and style in mind. In-home features include: Quartz or Marble Countertops, Garden Tubs & Walk-In Showers, Wood Style Flooring, Stainless Steel Appliances, Deep, Single-Basin Sinks, In-Home Washer and Dryers. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_bab31138-a840-4060-ae12-ab5e46b484ac",
      "question": "What restaurants and shops are near 2050 Morningside?",
      "answer": "2050 Morningside sits close to everyday conveniences and local favorites, including The Colonnade (0.5 mi), Nino's Italian Restaurant (0.3 mi), Publix Super Market at Cheshire Square (0.9 mi), Target (1.6 mi). See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-19b8-745e-a155-430a862ee347",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "2050-morningside",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296"
    },
    {
      "lead_collector_id": "0198aa45-1a1a-764d-8c0d-83867a3929c5",
      "lead_source": "FACEBOOK_ADS",
      "name": "2050-morningside",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296"
    },
    {
      "lead_collector_id": "0198aa45-1a7b-7698-8522-e798313305b3",
      "lead_source": "LANDING_PAGE",
      "name": "2050-morningside",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-atlanta-ga-2050",
      "search_query": "One Bedroom Apartments For Rent In Atlanta GA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Atlanta GA at 2050 Morningside",
      "h2_subtitle": "Discover the artfully styled living at 2050 Morningside. Our one-bedroom apartments offer modern finishes and lux amenities in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our one-bedroom apartments for rent in Atlanta GA feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | One Bedroom Apartments For Rent In Atlanta GA",
      "seo_description": "Explore one bedroom apartments for rent in Atlanta GA at 2050 Morningside. Enjoy modern finishes, lux amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-in-atlanta-ga",
      "search_query": "Two Bedrooms Apartments For Rent In Atlanta GA",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Atlanta GA at 2050 Morningside",
      "h2_subtitle": "Experience artfully styled living at 2050 Morningside. Our two-bedroom apartments offer modern finishes and luxurious amenities in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our two bedrooms apartments for rent in Atlanta GA feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Two Bedrooms Apartments For Rent In Atlanta GA",
      "seo_description": "Explore two bedrooms apartments for rent in Atlanta GA at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pool-at-morningside",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pool at 2050 Morningside",
      "h2_subtitle": "Discover luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, including a stunning pool, in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent near me with pool feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent Near Me with Pool",
      "seo_description": "Explore apartments for rent near me with pool at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fitness Center at 2050 Morningside",
      "h2_subtitle": "Experience luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, including a 24-hour fitness center, in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent near me with fitness center feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a 24-hour fitness center, sun-drenched pool, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Explore apartments for rent near me with fitness center at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-lounge-at-2050",
      "search_query": "Apartments For Rent Near Me with Lounge",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Lounge at 2050 Morningside",
      "h2_subtitle": "Discover luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, including a resident lounge, in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent near me with lounge feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a resident lounge, sun-drenched pool, 24-hour fitness center, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent Near Me with Lounge",
      "seo_description": "Explore apartments for rent near me with lounge at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-courtyard",
      "search_query": "Apartments For Rent Near Me with Courtyard",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Courtyard at 2050 Morningside",
      "h2_subtitle": "Experience luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, including a beautiful courtyard, in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent near me with courtyard feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a beautiful courtyard, sun-drenched pool, 24-hour fitness center, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent Near Me with Courtyard",
      "seo_description": "Explore apartments for rent near me with courtyard at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-sundeck-at-2050",
      "search_query": "Apartments For Rent Near Me with Sundeck",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Sundeck at 2050 Morningside",
      "h2_subtitle": "Discover luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, including a stunning sundeck, in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent near me with sundeck feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sundeck, sun-drenched pool, 24-hour fitness center, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent Near Me with Sundeck",
      "seo_description": "Explore apartments for rent near me with sundeck at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-kitchen-at-2050",
      "search_query": "Apartments For Rent Near Me with Kitchen",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Kitchen at 2050 Morningside",
      "h2_subtitle": "Experience luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, including custom kitchens, in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent near me with kitchen feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent Near Me with Kitchen",
      "seo_description": "Explore apartments for rent near me with kitchen at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-stainless-steel-appliances",
      "search_query": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Stainless Steel Appliances at 2050 Morningside",
      "h2_subtitle": "Discover luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, including stainless steel appliances, in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent near me with stainless steel appliances feature custom kitchens with quartz or marble countertops, full-size in-home washers and dryers, and stainless steel appliance packages. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent Near Me with Stainless Steel Appliances",
      "seo_description": "Explore apartments for rent near me with stainless steel appliances at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-hardwood-floors",
      "search_query": "Apartments For Rent Near Me with Hardwood Floors",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Hardwood Floors at 2050 Morningside",
      "h2_subtitle": "Experience luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, including hardwood floors, in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent near me with hardwood floors feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent Near Me with Hardwood Floors",
      "seo_description": "Explore apartments for rent near me with hardwood floors at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-tile-floors",
      "search_query": "Apartments For Rent Near Me with Tile Floors",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Tile Floors at 2050 Morningside",
      "h2_subtitle": "Discover luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, including tile floors, in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent near me with tile floors feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent Near Me with Tile Floors",
      "seo_description": "Explore apartments for rent near me with tile floors at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-washer-dryer",
      "search_query": "Apartments For Rent Near Me with Washer/Dryer",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Washer/Dryer at 2050 Morningside",
      "h2_subtitle": "Experience luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, including in-home washers and dryers, in a prime Atlanta location.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent near me with washer/dryer feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent Near Me with Washer/Dryer",
      "seo_description": "Explore apartments for rent near me with washer/dryer at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-atlanta-ga-near-piedmont-2050",
      "search_query": "Apartments For Rent In Atlanta GA Near Piedmont Atlanta",
      "category": "POI",
      "h1_title": "Apartments For Rent In Atlanta GA Near Piedmont Atlanta at 2050 Morningside",
      "h2_subtitle": "Discover luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, conveniently located near Piedmont Atlanta Hospital.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent in Atlanta GA near Piedmont Atlanta feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside, just a short distance from Piedmont Atlanta Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent In Atlanta GA Near Piedmont Atlanta",
      "seo_description": "Explore apartments for rent in Atlanta GA near Piedmont Atlanta at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-atlanta-near-childrens-healthcare",
      "search_query": "Apartments For Rent In Atlanta GA Near Children's Healthcare of Atlanta - Scottish Rite Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In Atlanta GA Near Children's Healthcare of Atlanta - Scottish Rite Hospital at 2050 Morningside",
      "h2_subtitle": "Experience luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, conveniently located near Children's Healthcare of Atlanta - Scottish Rite Hospital.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent in Atlanta GA near Children's Healthcare of Atlanta - Scottish Rite Hospital feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside, just a short distance from Children's Healthcare of Atlanta - Scottish Rite Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent In Atlanta GA Near Children's Healthcare of Atlanta - Scottish Rite Hospital",
      "seo_description": "Explore apartments for rent in Atlanta GA near Children's Healthcare of Atlanta - Scottish Rite Hospital at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-atlanta-near-northside-hospital",
      "search_query": "Apartments For Rent In Atlanta GA Near Northside Hospital Atlanta",
      "category": "POI",
      "h1_title": "Apartments For Rent In Atlanta GA Near Northside Hospital Atlanta at 2050 Morningside",
      "h2_subtitle": "Discover luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, conveniently located near Northside Hospital Atlanta.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent in Atlanta GA near Northside Hospital Atlanta feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside, just a short distance from Northside Hospital Atlanta.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent In Atlanta GA Near Northside Hospital Atlanta",
      "seo_description": "Explore apartments for rent in Atlanta GA near Northside Hospital Atlanta at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-atlanta-near-georgia-tech",
      "search_query": "Apartments For Rent In Atlanta GA Near Georgia Institute of Technology",
      "category": "POI",
      "h1_title": "Apartments For Rent In Atlanta GA Near Georgia Institute of Technology at 2050 Morningside",
      "h2_subtitle": "Experience luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, conveniently located near Georgia Institute of Technology.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent in Atlanta GA near Georgia Institute of Technology feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside, just a short distance from Georgia Institute of Technology.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent In Atlanta GA Near Georgia Institute of Technology",
      "seo_description": "Explore apartments for rent in Atlanta GA near Georgia Institute of Technology at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-atlanta-near-spelman-college",
      "search_query": "Apartments For Rent In Atlanta GA Near Spelman College",
      "category": "POI",
      "h1_title": "Apartments For Rent In Atlanta GA Near Spelman College at 2050 Morningside",
      "h2_subtitle": "Experience luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, conveniently located near Spelman College.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent in Atlanta GA near Spelman College feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside, just a short distance from Spelman College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent In Atlanta GA Near Spelman College",
      "seo_description": "Explore apartments for rent in Atlanta GA near Spelman College at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-atlanta-ga-near-georgia-state-university",
      "search_query": "Apartments For Rent In Atlanta GA Near Georgia State University",
      "category": "POI",
      "h1_title": "Apartments For Rent In Atlanta GA Near Georgia State University at 2050 Morningside",
      "h2_subtitle": "Experience luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, conveniently located near Georgia State University.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent in Atlanta GA near Georgia State University feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside, just a short distance from Georgia State University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent In Atlanta GA Near Georgia State University",
      "seo_description": "Explore apartments for rent in Atlanta GA near Georgia State University at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-atlanta-ga-near-atlanta-metropolitan",
      "search_query": "Apartments For Rent In Atlanta GA Near Atlanta Metropolitan State College",
      "category": "POI",
      "h1_title": "Apartments For Rent In Atlanta GA Near Atlanta Metropolitan State College at 2050 Morningside",
      "h2_subtitle": "Experience luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, conveniently located near Atlanta Metropolitan State College.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent in Atlanta GA near Atlanta Metropolitan State College feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside, just a short distance from Atlanta Metropolitan State College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent In Atlanta GA Near Atlanta Metropolitan State College",
      "seo_description": "Explore apartments for rent in Atlanta GA near Atlanta Metropolitan State College at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5656808622391296",
      "source": "custom",
      "page_item_url": "apartments-for-rent-atlanta-ga-near-oglethorpe-univ",
      "search_query": "Apartments For Rent In Atlanta GA Near Oglethorpe University",
      "category": "POI",
      "h1_title": "Apartments For Rent In Atlanta GA Near Oglethorpe University at 2050 Morningside",
      "h2_subtitle": "Experience luxurious living at 2050 Morningside. Our apartments offer modern finishes and exclusive amenities, conveniently located near Oglethorpe University.",
      "page_copy": "Welcome to 2050 Morningside, where you can Live Beyond The Canvas! Our apartments for rent in Atlanta GA near Oglethorpe University feature custom kitchens with quartz or marble countertops, stainless steel appliances, and full-size in-home washers and dryers. Enjoy wood plank and plush custom flooring, ceiling fans in every room, and luxurious bathrooms with garden tubs and walk-in showers. Located minutes from I-85, I-75, and GA400, 2050 Morningside offers easy access to Midtown, Buckhead, and top shopping destinations like Phipps Plaza and Lenox Square. Residents also enjoy exclusive amenities including a stunning sun-drenched pool, 24-hour fitness center, resident lounge, and rooftop sky lounge. Experience the best of Atlanta living at 2050 Morningside, just a short distance from Oglethorpe University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with an outdoor swimming pool and lounge chairs.",
        "public_id": "019f6c0b-075e-77ad-973c-9773fdef370a",
        "storage_key": "property/5656808622391296/019f6c0b-075e-77ad-973c-9773fdef370a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0b-11c2-75eb-a5b8-9e14975cb357",
        "storage_key": "property/5656808622391296/019f6c0b-11c2-75eb-a5b8-9e14975cb357.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "2050 Morningside | Apartments For Rent In Atlanta GA Near Oglethorpe University",
      "seo_description": "Explore apartments for rent in Atlanta GA near Oglethorpe University at 2050 Morningside. Enjoy modern finishes, luxurious amenities, and a prime location near Midtown and Buckhead.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2283"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2505043778"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a10\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a10\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4981185"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5B6V2KQ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "2555093788"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "bc2811f1ec3abf64"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dqw9e4r3po9"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/b74549d2-91ac-4718-967c-c57b4f3cfb43"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "470-470-9686"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik91R013NklIY09YSktNNVBkcWhVZXc9PSIsInZhbHVlIjoiZVBWUXAvWXZpM0wrVllxalZCRnJrdz09IiwibWFjIjoiYzUzMTdlZjA0NmYwYjM0ZDVmMmE2YWE0M2FmOTQ0NTlkOTBiNWI4NDhiYmJhYjE1M2YwNDE0NWE2OTEwZDhkZSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2283",
  "custom_repli_id": "2505043778",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a10\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a10\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4981185",
  "custom_google_gtm_id": "GTM-5B6V2KQ",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "2555093788",
  "custom_knock_community_id": "bc2811f1ec3abf64",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dqw9e4r3po9",
  "custom_self_guided_tour_url": "https://selftournow.com/property/b74549d2-91ac-4718-967c-c57b4f3cfb43",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "470-470-9686",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik91R013NklIY09YSktNNVBkcWhVZXc9PSIsInZhbHVlIjoiZVBWUXAvWXZpM0wrVllxalZCRnJrdz09IiwibWFjIjoiYzUzMTdlZjA0NmYwYjM0ZDVmMmE2YWE0M2FmOTQ0NTlkOTBiNWI4NDhiYmJhYjE1M2YwNDE0NWE2OTEwZDhkZSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "6e553e06-af07-4da0-b784-bbb798389ead",
  "custom_audioeye_site_hash": "ef863f3d08f7033094d9b6afca828ecf"
};

export const generatedAt = '2026-11-03T20:39:22.194Z';
